export const DictionaryIllustrator_ja_JP = [
    {
        id: 18,
        label: '編集 > 前面へペースト',
        placement: 'MenuBar',
        name: '前面へペースト',
    },
    {
        id: 19,
        label: '編集 > 背面へペースト',
        placement: 'MenuBar',
        name: '背面へペースト',
    },
    {
        id: 20,
        label: 'ファイル > テンプレートから新規...',
        placement: 'MenuBar',
        name: 'テンプレートから新規...',
    },
    {
        id: 22,
        label: 'オブジェクト > 変形 > 変形の繰り返し',
        placement: 'MenuBar',
        name: '変形の繰り返し',
    },
    {
        id: 23,
        label: 'オブジェクト > グループ',
        placement: 'MenuBar',
        name: 'グループ',
    },
    {
        id: 24,
        label: 'オブジェクト > グループ解除',
        placement: 'MenuBar',
        name: 'グループ解除',
    },
    {
        id: 25,
        label: 'オブジェクト > パス > 連結',
        placement: 'MenuBar',
        name: '連結',
    },
    {
        id: 26,
        label: 'オブジェクト > パス > 平均...',
        placement: 'MenuBar',
        name: '平均...',
    },
    {
        id: 28,
        label: 'オブジェクト > ロック > 選択',
        placement: 'MenuBar',
        name: '選択',
    },
    {
        id: 29,
        label: 'オブジェクト > すべてをロック解除',
        placement: 'MenuBar',
        name: 'すべてをロック解除',
    },
    {
        id: 30,
        label: '表示 > プレビュー',
        placement: 'MenuBar',
        name: 'プレビュー',
    },
    {
        id: 33,
        label: '表示 > ピクセルプレビュー',
        placement: 'MenuBar',
        name: 'ピクセルプレビュー',
    },
    {
        id: 34,
        label: '書式 > エリア内文字オプション...',
        placement: 'MenuBar',
        name: 'エリア内文字オプション...',
    },
    {
        id: 35,
        label: '表示 > アートボードを全体表示',
        placement: 'MenuBar',
        name: 'アートボードを全体表示',
    },
    {
        id: 36,
        label: 'ウィンドウ > 新規ウィンドウ',
        placement: 'MenuBar',
        name: '新規ウィンドウ',
    },
    {
        id: 37,
        label: '表示 > 定規 > 定規を表示',
        placement: 'MenuBar',
        name: '定規を表示',
    },
    {
        id: 38,
        label: '書式 > パス上文字オプション > 3D リボン',
        placement: 'MenuBar',
        name: '3D リボン',
    },
    {
        id: 40,
        label: '書式 > パス上文字オプション > 階段',
        placement: 'MenuBar',
        name: '階段',
    },
    {
        id: 42,
        label: 'オブジェクト > 重ね順 > 最前面へ',
        placement: 'MenuBar',
        name: '最前面へ',
    },
    {
        id: 43,
        label: 'オブジェクト > 重ね順 > 最背面へ',
        placement: 'MenuBar',
        name: '最背面へ',
    },
    {
        id: 48,
        label: 'ファイル > テンプレートとして保存...',
        placement: 'MenuBar',
        name: 'テンプレートとして保存...',
    },
    {
        id: 50,
        label: 'オブジェクト > 隠す > 選択',
        placement: 'MenuBar',
        name: '選択',
    },
    {
        id: 51,
        label: 'オブジェクト > すべてを表示',
        placement: 'MenuBar',
        name: 'すべてを表示',
    },
    {
        id: 52,
        label: '表示 > ガイド > ガイドを作成',
        placement: 'MenuBar',
        name: 'ガイドを作成',
    },
    {
        id: 53,
        label: '表示 > ガイド > ガイドを解除',
        placement: 'MenuBar',
        name: 'ガイドを解除',
    },
    {
        id: 54,
        label: 'オブジェクト > 変形 > 移動...',
        placement: 'MenuBar',
        name: '移動...',
    },
    {
        id: 55,
        label: 'Illustrator > 環境設定 > スマートガイド...',
        placement: 'MenuBar',
        name: 'スマートガイド...',
    },
    {
        id: 56,
        label: 'オブジェクト > 複合パス > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 57,
        label: 'オブジェクト > 複合パス > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 62,
        label: '書式 > アウトラインを作成',
        placement: 'MenuBar',
        name: 'アウトラインを作成',
    },
    {
        id: 63,
        label: '表示 > 100% 表示',
        placement: 'MenuBar',
        name: '100% 表示',
    },
    {
        id: 74,
        label: 'オブジェクト > グラフ > 設定...',
        placement: 'MenuBar',
        name: '設定...',
    },
    {
        id: 75,
        label: 'オブジェクト > グラフ > データ...',
        placement: 'MenuBar',
        name: 'データ...',
    },
    {
        id: 76,
        label: 'オブジェクト > グラフ > 棒グラフ...',
        placement: 'MenuBar',
        name: '棒グラフ...',
    },
    {
        id: 77,
        label: 'オブジェクト > グラフ > デザイン...',
        placement: 'MenuBar',
        name: 'デザイン...',
    },
    {
        id: 78,
        label: 'オブジェクト > グラフ > マーカー...',
        placement: 'MenuBar',
        name: 'マーカー...',
    },
    {
        id: 83,
        label: '書式 > パス上文字オプション > 虹',
        placement: 'MenuBar',
        name: '虹',
    },
    {
        id: 84,
        label: 'ファイル > ドキュメント設定...',
        placement: 'MenuBar',
        name: 'ドキュメント設定...',
    },
    {
        id: 85,
        label: '表示 > プリント分割を隠す',
        placement: 'MenuBar',
        name: 'プリント分割を隠す',
    },
    {
        id: 86,
        label: '表示 > アートボードを隠す',
        placement: 'MenuBar',
        name: 'アートボードを隠す',
    },
    {
        id: 87,
        label: '書式 > ヘッドラインを合わせる',
        placement: 'MenuBar',
        name: 'ヘッドラインを合わせる',
    },
    {
        id: 95,
        label: 'ファイル > コピーを保存...',
        placement: 'MenuBar',
        name: 'コピーを保存...',
    },
    {
        id: 98,
        label: 'Illustrator > 環境設定 > テキスト...',
        placement: 'MenuBar',
        name: 'テキスト...',
    },
    {
        id: 99,
        label: 'Illustrator > 環境設定 > 単位...',
        placement: 'MenuBar',
        name: '単位...',
    },
    {
        id: 100,
        label: 'オブジェクト > 重ね順 > 前面へ',
        placement: 'MenuBar',
        name: '前面へ',
    },
    {
        id: 101,
        label: 'オブジェクト > 重ね順 > 背面へ',
        placement: 'MenuBar',
        name: '背面へ',
    },
    {
        id: 109,
        label: 'ウィンドウ > アレンジ > ウィンドウを最小化',
        placement: 'MenuBar',
        name: 'ウィンドウを最小化',
    },
    {
        id: 110,
        label: 'ウィンドウ > アレンジ > すべてを前面へ',
        placement: 'MenuBar',
        name: 'すべてを前面へ',
    },
    {
        id: 113,
        label: '表示 > ガイド > ガイドを消去',
        placement: 'MenuBar',
        name: 'ガイドを消去',
    },
    {
        id: 114,
        label: '表示 > テンプレートを表示',
        placement: 'MenuBar',
        name: 'テンプレートを表示',
    },
    {
        id: 115,
        label: '書式 > 制御文字を表示',
        placement: 'MenuBar',
        name: '制御文字を表示',
    },
    {
        id: 116,
        label: '書式 > パス上文字オプション > 歪み',
        placement: 'MenuBar',
        name: '歪み',
    },
    {
        id: 117,
        label: 'ファイル > すべてを閉じる',
        placement: 'MenuBar',
        name: 'すべてを閉じる',
    },
    {
        id: 119,
        label: '書式 > パス上文字オプション > 引力',
        placement: 'MenuBar',
        name: '引力',
    },
    {
        id: 120,
        label: 'オブジェクト > クリッピングマスク > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 121,
        label: 'オブジェクト > クリッピングマスク > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 123,
        label: '書式 > パス上文字オプション > パス上文字オプション...',
        placement: 'MenuBar',
        name: 'パス上文字オプション...',
    },
    {
        id: 127,
        label: 'オブジェクト > アートボード > アートボードに変換',
        placement: 'MenuBar',
        name: 'アートボードに変換',
    },
    {
        id: 133,
        label: '書式 > スレッドテキストオプション > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 135,
        label: '表示 > ズームイン',
        placement: 'MenuBar',
        name: 'ズームイン',
    },
    {
        id: 136,
        label: '表示 > ズームアウト',
        placement: 'MenuBar',
        name: 'ズームアウト',
    },
    {
        id: 139,
        label: '編集 > カラー設定...',
        placement: 'MenuBar',
        name: 'カラー設定...',
    },
    {
        id: 140,
        label: 'Illustrator > 環境設定 > ハイフネーション...',
        placement: 'MenuBar',
        name: 'ハイフネーション...',
    },
    {
        id: 141,
        label: 'Illustrator > 環境設定 > プラグイン・仮想記憶ディスク...',
        placement: 'MenuBar',
        name: 'プラグイン・仮想記憶ディスク...',
    },
    {
        id: 142,
        label: '選択 > 選択を解除',
        placement: 'MenuBar',
        name: '選択を解除',
    },
    {
        id: 143,
        label: '表示 > オーバープリントプレビュー',
        placement: 'MenuBar',
        name: 'オーバープリントプレビュー',
    },
    {
        id: 144,
        label: '表示 > 新規表示...',
        placement: 'MenuBar',
        name: '新規表示...',
    },
    {
        id: 145,
        label: '表示 > 表示の編集...',
        placement: 'MenuBar',
        name: '表示の編集...',
    },
    {
        id: 146,
        label: '表示 > ポイントにスナップ',
        placement: 'MenuBar',
        name: 'ポイントにスナップ',
    },
    {
        id: 147,
        label: '表示 > 境界線を隠す',
        placement: 'MenuBar',
        name: '境界線を隠す',
    },
    {
        id: 148,
        label: 'オブジェクト > アピアランスを分割',
        placement: 'MenuBar',
        name: 'アピアランスを分割',
    },
    {
        id: 150,
        label: '表示 > テキストのスレッドを表示',
        placement: 'MenuBar',
        name: 'テキストのスレッドを表示',
    },
    {
        id: 154,
        label: '表示 > ガイド > ガイドを隠す',
        placement: 'MenuBar',
        name: 'ガイドを隠す',
    },
    {
        id: 155,
        label: '表示 > ガイド > ガイドをロック',
        placement: 'MenuBar',
        name: 'ガイドをロック',
    },
    {
        id: 157,
        label: '書式 > スレッドテキストオプション > 選択部分をスレッドから除外',
        placement: 'MenuBar',
        name: '選択部分をスレッドから除外',
    },
    {
        id: 158,
        label: '書式 > スレッドテキストオプション > スレッドのリンクを解除',
        placement: 'MenuBar',
        name: 'スレッドのリンクを解除',
    },
    {
        id: 159,
        label: '表示 > グリッドを表示',
        placement: 'MenuBar',
        name: 'グリッドを表示',
    },
    {
        id: 160,
        label: '表示 > グリッドにスナップ',
        placement: 'MenuBar',
        name: 'グリッドにスナップ',
    },
    {
        id: 161,
        label: 'Illustrator > 環境設定 > ガイド・グリッド...',
        placement: 'MenuBar',
        name: 'ガイド・グリッド...',
    },
    {
        id: 162,
        label: 'オブジェクト > 変形 > 回転...',
        placement: 'MenuBar',
        name: '回転...',
    },
    {
        id: 163,
        label: 'オブジェクト > 変形 > 拡大・縮小...',
        placement: 'MenuBar',
        name: '拡大・縮小...',
    },
    {
        id: 164,
        label: 'オブジェクト > 変形 > リフレクト...',
        placement: 'MenuBar',
        name: 'リフレクト...',
    },
    {
        id: 165,
        label: 'オブジェクト > 変形 > シアー...',
        placement: 'MenuBar',
        name: 'シアー...',
    },
    {
        id: 166,
        label: 'ウィンドウ > アレンジ > 重ねて表示',
        placement: 'MenuBar',
        name: '重ねて表示',
    },
    {
        id: 168,
        label: 'ウィンドウ > アレンジ > 並べて表示',
        placement: 'MenuBar',
        name: '並べて表示',
    },
    {
        id: 202,
        label: '表示 > 色の校正',
        placement: 'MenuBar',
        name: '色の校正',
    },
    {
        id: 203,
        label: '編集 > プロファイルの指定...',
        placement: 'MenuBar',
        name: 'プロファイルの指定...',
    },
    {
        id: 204,
        label: 'ヘルプ > チュートリアル...',
        placement: 'MenuBar',
        name: 'チュートリアル...',
    },
    {
        id: 223,
        label: 'ファイル > ドキュメントのカラーモード > CMYK カラー',
        placement: 'MenuBar',
        name: 'CMYK カラー',
    },
    {
        id: 224,
        label: 'ファイル > ドキュメントのカラーモード > RGB カラー',
        placement: 'MenuBar',
        name: 'RGB カラー',
    },
    {
        id: 225,
        label: '表示 > 校正設定 > ドキュメント CMYK :',
        placement: 'MenuBar',
        name: 'ドキュメント CMYK :',
    },
    {
        id: 226,
        label: '表示 > 校正設定 > 以前の Macintosh RGB (ガンマ 1.8)',
        placement: 'MenuBar',
        name: '以前の Macintosh RGB (ガンマ 1.8)',
    },
    {
        id: 227,
        label: '表示 > 校正設定 > インターネット標準 RGB (sRGB)',
        placement: 'MenuBar',
        name: 'インターネット標準 RGB (sRGB)',
    },
    {
        id: 228,
        label: '表示 > 校正設定 > モニター RGB',
        placement: 'MenuBar',
        name: 'モニター RGB',
    },
    {
        id: 229,
        label: '書式 > 組み方向 > 横組み',
        placement: 'MenuBar',
        name: '横組み',
    },
    {
        id: 230,
        label: '書式 > 組み方向 > 縦組み',
        placement: 'MenuBar',
        name: '縦組み',
    },
    {
        id: 232,
        label: 'ヘルプ > システム情報...',
        placement: 'MenuBar',
        name: 'システム情報...',
    },
    {
        id: 278,
        label: '書式 > テキストを更新 > すべてのテキストを更新',
        placement: 'MenuBar',
        name: 'すべてのテキストを更新',
    },
    {
        id: 279,
        label: '書式 > テキストを更新 > 選択したテキストを更新',
        placement: 'MenuBar',
        name: '選択したテキストを更新',
    },
    {
        id: 280,
        label: '書式 > テキストを更新 > コピーを隠す',
        placement: 'MenuBar',
        name: 'コピーを隠す',
    },
    {
        id: 281,
        label: '書式 > テキストを更新 > コピーを削除',
        placement: 'MenuBar',
        name: 'コピーを削除',
    },
    {
        id: 282,
        label: '書式 > テキストを更新 > コピーを選択',
        placement: 'MenuBar',
        name: 'コピーを選択',
    },
    {
        id: 284,
        label: '表示 > 校正設定 > カスタム...',
        placement: 'MenuBar',
        name: 'カスタム...',
    },
    {
        id: 289,
        label: 'Illustrator > 環境設定 > 選択範囲・アンカー表示...',
        placement: 'MenuBar',
        name: '選択範囲・アンカー表示...',
    },
    {
        id: 292,
        label: 'オブジェクト > クリッピングマスク > オブジェクトを編集',
        placement: 'MenuBar',
        name: 'オブジェクトを編集',
    },
    {
        id: 293,
        label: 'Illustrator > 環境設定 > ユーザーインターフェイス...',
        placement: 'MenuBar',
        name: 'ユーザーインターフェイス...',
    },
    {
        id: 294,
        label: 'Illustrator > 環境設定 > スライス...',
        placement: 'MenuBar',
        name: 'スライス...',
    },
    {
        id: 295,
        label: 'ウィンドウ > アプリケーションフレーム',
        placement: 'MenuBar',
        name: 'アプリケーションフレーム',
    },
    {
        id: 296,
        label: '表示 > 校正設定 > P 型 (1 型) 色覚',
        placement: 'MenuBar',
        name: 'P 型 (1 型) 色覚',
    },
    {
        id: 297,
        label: '表示 > 校正設定 > D 型 (2 型) 色覚',
        placement: 'MenuBar',
        name: 'D 型 (2 型) 色覚',
    },
    {
        id: 299,
        label: '表示 > 定規 > ビデオ定規を表示',
        placement: 'MenuBar',
        name: 'ビデオ定規を表示',
    },
    {
        id: 301,
        label: 'ウィンドウ > アレンジ > ウィンドウを分離',
        placement: 'MenuBar',
        name: 'ウィンドウを分離',
    },
    {
        id: 302,
        label: 'ウィンドウ > アレンジ > すべてのウィンドウを分離',
        placement: 'MenuBar',
        name: 'すべてのウィンドウを分離',
    },
    {
        id: 303,
        label: 'ウィンドウ > アレンジ > すべてのウィンドウを統合',
        placement: 'MenuBar',
        name: 'すべてのウィンドウを統合',
    },
    {
        id: 304,
        label: 'ウィンドウ > アプリケーションバー',
        placement: 'MenuBar',
        name: 'アプリケーションバー',
    },
    {
        id: 310,
        label: '書式 > パス上文字オプション > パス上文字を更新',
        placement: 'MenuBar',
        name: 'パス上文字を更新',
    },
    {
        id: 311,
        label: '表示 > すべてのアートボードを全体表示',
        placement: 'MenuBar',
        name: 'すべてのアートボードを全体表示',
    },
    {
        id: 315,
        label: '編集 > 同じ位置にペースト',
        placement: 'MenuBar',
        name: '同じ位置にペースト',
    },
    {
        id: 316,
        label: '編集 > すべてのアートボードにペースト',
        placement: 'MenuBar',
        name: 'すべてのアートボードにペースト',
    },
    {
        id: 331,
        label: '書式 > 文字の種類を切り換え',
        placement: 'MenuBar',
        name: '文字の種類を切り換え',
    },
    {
        id: 339,
        label: '編集 > 個別の設定 > 設定の書き出し...',
        placement: 'MenuBar',
        name: '設定の書き出し...',
    },
    {
        id: 340,
        label: '編集 > 個別の設定 > 設定の読み込み...',
        placement: 'MenuBar',
        name: '設定の読み込み...',
    },
    {
        id: 347,
        label: '表示 > GPU で表示',
        placement: 'MenuBar',
        name: 'GPU で表示',
    },
    {
        id: 351,
        label: 'ファイル > 選択範囲を書き出し...',
        placement: 'MenuBar',
        name: '選択範囲を書き出し...',
    },
    {
        id: 353,
        label: '表示 > ピクセルにスナップ',
        placement: 'MenuBar',
        name: 'ピクセルにスナップ',
    },
    {
        id: 354,
        label: 'ファイル > 書き出し > スクリーン用に書き出し...',
        placement: 'MenuBar',
        name: 'スクリーン用に書き出し...',
    },
    {
        id: 355,
        label: 'ファイル > 書き出し > 書き出し形式...',
        placement: 'MenuBar',
        name: '書き出し形式...',
    },
    {
        id: 356,
        label: 'ファイル > 書き出し > Web 用に保存 (従来)...',
        placement: 'MenuBar',
        name: 'Web 用に保存 (従来)...',
    },
    {
        id: 368,
        label: '書式 > 特殊文字を挿入 > 記号 > ビュレット',
        placement: 'MenuBar',
        name: 'ビュレット',
    },
    {
        id: 369,
        label: '書式 > 特殊文字を挿入 > 記号 > 著作権記号',
        placement: 'MenuBar',
        name: '著作権記号',
    },
    {
        id: 370,
        label: '書式 > 特殊文字を挿入 > 記号 > 省略記号',
        placement: 'MenuBar',
        name: '省略記号',
    },
    {
        id: 371,
        label: '書式 > 特殊文字を挿入 > 記号 > 段落記号',
        placement: 'MenuBar',
        name: '段落記号',
    },
    {
        id: 372,
        label: '書式 > 特殊文字を挿入 > 記号 > 登録商標記号',
        placement: 'MenuBar',
        name: '登録商標記号',
    },
    {
        id: 373,
        label: '書式 > 特殊文字を挿入 > 記号 > セクション記号',
        placement: 'MenuBar',
        name: 'セクション記号',
    },
    {
        id: 374,
        label: '書式 > 特殊文字を挿入 > 記号 > 商標記号',
        placement: 'MenuBar',
        name: '商標記号',
    },
    {
        id: 375,
        label: '書式 > 特殊文字を挿入 > 引用符 > 左二重引用符',
        placement: 'MenuBar',
        name: '左二重引用符',
    },
    {
        id: 376,
        label: '書式 > 特殊文字を挿入 > 引用符 > 右二重引用符',
        placement: 'MenuBar',
        name: '右二重引用符',
    },
    {
        id: 377,
        label: '書式 > 特殊文字を挿入 > 引用符 > 左一重引用符',
        placement: 'MenuBar',
        name: '左一重引用符',
    },
    {
        id: 378,
        label: '書式 > 特殊文字を挿入 > 引用符 > 右一重引用符',
        placement: 'MenuBar',
        name: '右一重引用符',
    },
    {
        id: 379,
        label: '書式 > 特殊文字を挿入 > ハイフンおよびダッシュ > EM ダッシュ',
        placement: 'MenuBar',
        name: 'EM ダッシュ',
    },
    {
        id: 380,
        label: '書式 > 特殊文字を挿入 > ハイフンおよびダッシュ > EN ダッシュ',
        placement: 'MenuBar',
        name: 'EN ダッシュ',
    },
    {
        id: 381,
        label: '書式 > 特殊文字を挿入 > ハイフンおよびダッシュ > 任意ハイフン',
        placement: 'MenuBar',
        name: '任意ハイフン',
    },
    {
        id: 382,
        label: '書式 > 空白文字を挿入 > EM スペース',
        placement: 'MenuBar',
        name: 'EM スペース',
    },
    {
        id: 383,
        label: '書式 > 空白文字を挿入 > EN スペース',
        placement: 'MenuBar',
        name: 'EN スペース',
    },
    {
        id: 384,
        label: '書式 > 空白文字を挿入 > 極細スペース',
        placement: 'MenuBar',
        name: '極細スペース',
    },
    {
        id: 385,
        label: '書式 > 空白文字を挿入 > 細いスペース',
        placement: 'MenuBar',
        name: '細いスペース',
    },
    {
        id: 386,
        label: '書式 > 分割文字を挿入 > 強制改行',
        placement: 'MenuBar',
        name: '強制改行',
    },
    {
        id: 391,
        label: '書式 > サンプルテキストの割り付け',
        placement: 'MenuBar',
        name: 'サンプルテキストの割り付け',
    },
    {
        id: 393,
        label: 'オブジェクト > 書き出し用に追加 > 単一のアセットとして',
        placement: 'MenuBar',
        name: '単一のアセットとして',
    },
    {
        id: 394,
        label: 'オブジェクト > 書き出し用に追加 > 複数のアセットとして',
        placement: 'MenuBar',
        name: '複数のアセットとして',
    },
    {
        id: 396,
        label: '表示 > トリミング表示',
        placement: 'MenuBar',
        name: 'トリミング表示',
    },
    {
        id: 397,
        label: '表示 > プレゼンテーションモード',
        placement: 'MenuBar',
        name: 'プレゼンテーションモード',
    },
    {
        id: 404,
        label: '表示 > スクリーンモード > 標準スクリーンモード',
        placement: 'MenuBar',
        name: '標準スクリーンモード',
    },
    {
        id: 405,
        label: '表示 > スクリーンモード > メニュー付きフルスクリーンモード',
        placement: 'MenuBar',
        name: 'メニュー付きフルスクリーンモード',
    },
    {
        id: 406,
        label: '表示 > スクリーンモード > フルスクリーンモード',
        placement: 'MenuBar',
        name: 'フルスクリーンモード',
    },
    {
        id: 411,
        label: '表示 > グリフにスナップ',
        placement: 'MenuBar',
        name: 'グリフにスナップ',
    },
    {
        id: 415,
        label: '表示 > 選択範囲に合わせてビューを回転',
        placement: 'MenuBar',
        name: '選択範囲に合わせてビューを回転',
    },
    {
        id: 417,
        label: '表示 > ビューを回転 > 180',
        placement: 'MenuBar',
        name: '180',
    },
    {
        id: 418,
        label: '表示 > ビューを回転 > 150',
        placement: 'MenuBar',
        name: '150',
    },
    {
        id: 419,
        label: '表示 > ビューを回転 > 135',
        placement: 'MenuBar',
        name: '135',
    },
    {
        id: 420,
        label: '表示 > ビューを回転 > 120',
        placement: 'MenuBar',
        name: '120',
    },
    {
        id: 421,
        label: '表示 > ビューを回転 > 90',
        placement: 'MenuBar',
        name: '90',
    },
    {
        id: 422,
        label: '表示 > ビューを回転 > 60',
        placement: 'MenuBar',
        name: '60',
    },
    {
        id: 423,
        label: '表示 > ビューを回転 > 45',
        placement: 'MenuBar',
        name: '45',
    },
    {
        id: 424,
        label: '表示 > ビューを回転 > 30',
        placement: 'MenuBar',
        name: '30',
    },
    {
        id: 425,
        label: '表示 > ビューを回転 > 15',
        placement: 'MenuBar',
        name: '15',
    },
    {
        id: 426,
        label: '表示 > ビューを回転 > 0',
        placement: 'MenuBar',
        name: '0',
    },
    {
        id: 427,
        label: '表示 > ビューを回転 > -15',
        placement: 'MenuBar',
        name: '-15',
    },
    {
        id: 428,
        label: '表示 > ビューを回転 > -30',
        placement: 'MenuBar',
        name: '-30',
    },
    {
        id: 429,
        label: '表示 > ビューを回転 > -45',
        placement: 'MenuBar',
        name: '-45',
    },
    {
        id: 430,
        label: '表示 > ビューを回転 > -60',
        placement: 'MenuBar',
        name: '-60',
    },
    {
        id: 431,
        label: '表示 > ビューを回転 > -90',
        placement: 'MenuBar',
        name: '-90',
    },
    {
        id: 432,
        label: '表示 > ビューを回転 > -120',
        placement: 'MenuBar',
        name: '-120',
    },
    {
        id: 433,
        label: '表示 > ビューを回転 > -135',
        placement: 'MenuBar',
        name: '-135',
    },
    {
        id: 434,
        label: '表示 > ビューを回転 > -150',
        placement: 'MenuBar',
        name: '-150',
    },
    {
        id: 435,
        label: '表示 > ビューを回転 > -180',
        placement: 'MenuBar',
        name: '-180',
    },
    {
        id: 436,
        label: '表示 > ビューを回転の初期化',
        placement: 'MenuBar',
        name: 'ビューを回転の初期化',
    },
    {
        id: 437,
        label: '編集 > 書式なしでペースト',
        placement: 'MenuBar',
        name: '書式なしでペースト',
    },
    {
        id: 438,
        label: 'ヘルプ > 新機能...',
        placement: 'MenuBar',
        name: '新機能...',
    },
    {
        id: 440,
        label: '書式 > 箇条書き > 記号を適用',
        placement: 'MenuBar',
        name: '記号を適用',
    },
    {
        id: 441,
        label: '書式 > 箇条書き > 番号を適用',
        placement: 'MenuBar',
        name: '番号を適用',
    },
    {
        id: 448,
        label: '書式 > 箇条書き > テキストに変換',
        placement: 'MenuBar',
        name: 'テキストに変換',
    },
    {
        id: 456,
        label: '書式 > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 471,
        label: 'オブジェクト > すべてグループ解除',
        placement: 'MenuBar',
        name: 'すべてグループ解除',
    },
    {
        id: 472,
        label: '書式 > 空白文字を挿入 > 分散禁止スペース',
        placement: 'MenuBar',
        name: '分散禁止スペース',
    },
    {
        id: 1383427079,
        label: '表示 > 定規 > アートボード定規に変更',
        placement: 'MenuBar',
        name: 'アートボード定規に変更',
    },
    {
        id: 1633841013,
        label: 'Illustrator > Illustrator について...',
        placement: 'MenuBar',
        name: 'Illustrator について...',
    },
    {
        id: 1634233456,
        label: 'ヘルプ > Illustrator ヘルプ...',
        placement: 'MenuBar',
        name: 'Illustrator ヘルプ...',
    },
    {
        id: 1634296684,
        label: 'ファイル > 閉じる',
        placement: 'MenuBar',
        name: '閉じる',
    },
    {
        id: 1668048225,
        label: '編集 > 消去',
        placement: 'MenuBar',
        name: '消去',
    },
    {
        id: 1668247673,
        label: '編集 > コピー',
        placement: 'MenuBar',
        name: 'コピー',
    },
    {
        id: 1668641824,
        label: '編集 > カット',
        placement: 'MenuBar',
        name: 'カット',
    },
    {
        id: 1751737445,
        label: 'Illustrator > Illustrator を隠す',
        placement: 'MenuBar',
        name: 'Illustrator を隠す',
    },
    {
        id: 1751737455,
        label: 'Illustrator > ほかを隠す',
        placement: 'MenuBar',
        name: 'ほかを隠す',
    },
    {
        id: 1852143392,
        label: 'ファイル > 新規...',
        placement: 'MenuBar',
        name: '新規...',
    },
    {
        id: 1869636974,
        label: 'ファイル > 開く...',
        placement: 'MenuBar',
        name: '開く...',
    },
    {
        id: 1885434740,
        label: '編集 > ペースト',
        placement: 'MenuBar',
        name: 'ペースト',
    },
    {
        id: 1886545254,
        label: 'Illustrator > 環境設定 > 一般...',
        placement: 'MenuBar',
        name: '一般...',
    },
    {
        id: 1903520116,
        label: 'Illustrator > Illustrator を終了',
        placement: 'MenuBar',
        name: 'Illustrator を終了',
    },
    {
        id: 1919247471,
        label: '編集 > やり直し',
        placement: 'MenuBar',
        name: 'やり直し',
    },
    {
        id: 1920365172,
        label: 'ファイル > 復帰',
        placement: 'MenuBar',
        name: '復帰',
    },
    {
        id: 1934727834,
        label: '選択 > 作業アートボードのすべてを選択',
        placement: 'MenuBar',
        name: '作業アートボードのすべてを選択',
    },
    {
        id: 1935764588,
        label: '選択 > すべてを選択',
        placement: 'MenuBar',
        name: 'すべてを選択',
    },
    {
        id: 1935767141,
        label: 'ファイル > 保存',
        placement: 'MenuBar',
        name: '保存',
    },
    {
        id: 1936220524,
        label: 'Illustrator > すべてを表示',
        placement: 'MenuBar',
        name: 'すべてを表示',
    },
    {
        id: 1936292352,
        label: '書式 > サイズ > 6 pt',
        placement: 'MenuBar',
        name: '6 pt',
    },
    {
        id: 1936292353,
        label: '書式 > サイズ > 7 pt',
        placement: 'MenuBar',
        name: '7 pt',
    },
    {
        id: 1936292354,
        label: '書式 > サイズ > 8 pt',
        placement: 'MenuBar',
        name: '8 pt',
    },
    {
        id: 1936292355,
        label: '書式 > サイズ > 9 pt',
        placement: 'MenuBar',
        name: '9 pt',
    },
    {
        id: 1936292356,
        label: '書式 > サイズ > 10 pt',
        placement: 'MenuBar',
        name: '10 pt',
    },
    {
        id: 1936292357,
        label: '書式 > サイズ > 11 pt',
        placement: 'MenuBar',
        name: '11 pt',
    },
    {
        id: 1936292358,
        label: '書式 > サイズ > 12 pt',
        placement: 'MenuBar',
        name: '12 pt',
    },
    {
        id: 1936292359,
        label: '書式 > サイズ > 14 pt',
        placement: 'MenuBar',
        name: '14 pt',
    },
    {
        id: 1936292360,
        label: '書式 > サイズ > 18 pt',
        placement: 'MenuBar',
        name: '18 pt',
    },
    {
        id: 1936292361,
        label: '書式 > サイズ > 21 pt',
        placement: 'MenuBar',
        name: '21 pt',
    },
    {
        id: 1936292362,
        label: '書式 > サイズ > 24 pt',
        placement: 'MenuBar',
        name: '24 pt',
    },
    {
        id: 1936292363,
        label: '書式 > サイズ > 36 pt',
        placement: 'MenuBar',
        name: '36 pt',
    },
    {
        id: 1936292364,
        label: '書式 > サイズ > 48 pt',
        placement: 'MenuBar',
        name: '48 pt',
    },
    {
        id: 1936292365,
        label: '書式 > サイズ > 60 pt',
        placement: 'MenuBar',
        name: '60 pt',
    },
    {
        id: 1936292366,
        label: '書式 > サイズ > 72 pt',
        placement: 'MenuBar',
        name: '72 pt',
    },
    {
        id: 1936292367,
        label: '書式 > サイズ > その他...',
        placement: 'MenuBar',
        name: 'その他...',
    },
    {
        id: 1937138035,
        label: 'ファイル > 別名で保存...',
        placement: 'MenuBar',
        name: '別名で保存...',
    },
    {
        id: 1970168943,
        label: '編集 > 取り消し',
        placement: 'MenuBar',
        name: '取り消し',
    },
    {
        id: 2164260867,
        label: 'ヘルプ > アカウントを管理…',
        placement: 'MenuBar',
        name: 'アカウントを管理…',
    },
    {
        id: 2164260869,
        label: 'ヘルプ > アップデート...',
        placement: 'MenuBar',
        name: 'アップデート...',
    },
    {
        id: 2164260870,
        label: '効果 > 前回の効果を適用',
        placement: 'MenuBar',
        name: '前回の効果を適用',
    },
    {
        id: 2164260871,
        label: '効果 > 前回の効果',
        placement: 'MenuBar',
        name: '前回の効果',
    },
    {
        id: 2164260872,
        label: 'ファイル > Adobe Stock を検索...',
        placement: 'MenuBar',
        name: 'Adobe Stock を検索...',
    },
    {
        id: 2164260873,
        label: 'ファイル > 配置...',
        placement: 'MenuBar',
        name: '配置...',
    },
    {
        id: 2164260874,
        label: 'オブジェクト > パス > アンカーポイントを削除',
        placement: 'MenuBar',
        name: 'アンカーポイントを削除',
    },
    {
        id: 2164260877,
        label: '書式 > 合成フォント...',
        placement: 'MenuBar',
        name: '合成フォント...',
    },
    {
        id: 2164260879,
        label: 'ヘルプ > Debug > Memory Use Checkpoint',
        placement: 'MenuBar',
        name: 'Memory Use Checkpoint',
    },
    {
        id: 2164260880,
        label: 'ヘルプ > Debug > Save Memory Use',
        placement: 'MenuBar',
        name: 'Save Memory Use',
    },
    {
        id: 2164260882,
        label: 'ヘルプ > Debug > Progress: Bar Shown',
        placement: 'MenuBar',
        name: 'Progress: Bar Shown',
    },
    {
        id: 2164260883,
        label: 'ヘルプ > Debug > Progress: Tight loop for 120 Seconds',
        placement: 'MenuBar',
        name: 'Progress: Tight loop for 120 Seconds',
    },
    {
        id: 2164260884,
        label: 'ヘルプ > Debug > Responsive Rate Test',
        placement: 'MenuBar',
        name: 'Responsive Rate Test',
    },
    {
        id: 2164260885,
        label: 'ヘルプ > Debug > Test Notification 1',
        placement: 'MenuBar',
        name: 'Test Notification 1',
    },
    {
        id: 2164260886,
        label: 'ヘルプ > Debug > Test Notification 2',
        placement: 'MenuBar',
        name: 'Test Notification 2',
    },
    {
        id: 2164260887,
        label: 'ヘルプ > Debug > Test Notification 3',
        placement: 'MenuBar',
        name: 'Test Notification 3',
    },
    {
        id: 2164260889,
        label: 'ヘルプ > Debug > Count Objects',
        placement: 'MenuBar',
        name: 'Count Objects',
    },
    {
        id: 2164260890,
        label: 'ヘルプ > Debug > Object Counts',
        placement: 'MenuBar',
        name: 'Object Counts',
    },
    {
        id: 2164260892,
        label: 'ヘルプ > Debug > Track API Refs',
        placement: 'MenuBar',
        name: 'Track API Refs',
    },
    {
        id: 2164260893,
        label: 'ヘルプ > Debug > Process Deep Link',
        placement: 'MenuBar',
        name: 'Process Deep Link',
    },
    {
        id: 2164260894,
        label: 'ヘルプ > Debug > Start Discover Panel Tour',
        placement: 'MenuBar',
        name: 'Start Discover Panel Tour',
    },
    {
        id: 2164260896,
        label: 'ヘルプ > Debug > Enable New Rendering',
        placement: 'MenuBar',
        name: 'Enable New Rendering',
    },
    {
        id: 2164260897,
        label: 'ヘルプ > Debug > Enable Rendering Timer',
        placement: 'MenuBar',
        name: 'Enable Rendering Timer',
    },
    {
        id: 2164260898,
        label: 'ヘルプ > Debug > Purge Rendering Cache',
        placement: 'MenuBar',
        name: 'Purge Rendering Cache',
    },
    {
        id: 2164260899,
        label: 'ヘルプ > Debug > Redraw',
        placement: 'MenuBar',
        name: 'Redraw',
    },
    {
        id: 2164260900,
        label: 'ヘルプ > Debug > Dump Application Heap Used',
        placement: 'MenuBar',
        name: 'Dump Application Heap Used',
    },
    {
        id: 2164260901,
        label: 'ヘルプ > Debug > Disable Greeking for New Rendering',
        placement: 'MenuBar',
        name: 'Disable Greeking for New Rendering',
    },
    {
        id: 2164260902,
        label: 'ヘルプ > Debug > Enable Threaded Rendering',
        placement: 'MenuBar',
        name: 'Enable Threaded Rendering',
    },
    {
        id: 2164260903,
        label: 'ヘルプ > Debug > Enable AGM Threading',
        placement: 'MenuBar',
        name: 'Enable AGM Threading',
    },
    {
        id: 2164260904,
        label: 'ヘルプ > Debug > Enable AGM Internal Memory Pool',
        placement: 'MenuBar',
        name: 'Enable AGM Internal Memory Pool',
    },
    {
        id: 2164260905,
        label: 'ヘルプ > Debug > Enable QuickPort Quartz',
        placement: 'MenuBar',
        name: 'Enable QuickPort Quartz',
    },
    {
        id: 2164260906,
        label: 'ヘルプ > Debug > Crash',
        placement: 'MenuBar',
        name: 'Crash',
    },
    {
        id: 2164260908,
        label: 'ヘルプ > Debug > Enable PGF Recovery',
        placement: 'MenuBar',
        name: 'Enable PGF Recovery',
    },
    {
        id: 2164260909,
        label: 'ヘルプ > Debug > Enable ATE Read Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Read Recovery',
    },
    {
        id: 2164260910,
        label: 'ヘルプ > Debug > Enable ATE Write Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Write Recovery',
    },
    {
        id: 2164260912,
        label: 'ウィンドウ > 情報',
        placement: 'MenuBar',
        name: '情報',
    },
    {
        id: 2164260914,
        label: 'ウィンドウ > 書式 > 文字',
        placement: 'MenuBar',
        name: '文字',
    },
    {
        id: 2164260915,
        label: 'ウィンドウ > 書式 > 段落',
        placement: 'MenuBar',
        name: '段落',
    },
    {
        id: 2164260916,
        label: 'ウィンドウ > 書式 > タブ',
        placement: 'MenuBar',
        name: 'タブ',
    },
    {
        id: 2164260917,
        label: 'ウィンドウ > 書式 > OpenType',
        placement: 'MenuBar',
        name: 'OpenType',
    },
    {
        id: 2164260918,
        label: '書式 > 文字組みアキ量設定...',
        placement: 'MenuBar',
        name: '文字組みアキ量設定...',
    },
    {
        id: 2164260919,
        label: '効果 > Photoshop 効果',
        placement: 'MenuBar',
        name: 'Photoshop 効果',
    },
    {
        id: 2164260922,
        label: '効果 > ぼかし > ぼかし (詳細)...',
        placement: 'MenuBar',
        name: 'ぼかし (詳細)...',
    },
    {
        id: 2164260923,
        label: '効果 > ぼかし > ぼかし (放射状)...',
        placement: 'MenuBar',
        name: 'ぼかし (放射状)...',
    },
    {
        id: 2164260925,
        label: '効果 > ピクセレート > 点描...',
        placement: 'MenuBar',
        name: '点描...',
    },
    {
        id: 2164260926,
        label: '効果 > ピクセレート > メゾティント...',
        placement: 'MenuBar',
        name: 'メゾティント...',
    },
    {
        id: 2164260928,
        label: '効果 > ビデオ > インターレース解除...',
        placement: 'MenuBar',
        name: 'インターレース解除...',
    },
    {
        id: 2164260929,
        label: '効果 > ピクセレート > 水晶...',
        placement: 'MenuBar',
        name: '水晶...',
    },
    {
        id: 2164260930,
        label: '効果 > ピクセレート > カラーハーフトーン...',
        placement: 'MenuBar',
        name: 'カラーハーフトーン...',
    },
    {
        id: 2164260931,
        label: '表示 > ライブペイントの隙間を表示',
        placement: 'MenuBar',
        name: 'ライブペイントの隙間を表示',
    },
    {
        id: 2164260934,
        label: 'オブジェクト > ライブペイント > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 2164260935,
        label: 'オブジェクト > ライブペイント > 結合',
        placement: 'MenuBar',
        name: '結合',
    },
    {
        id: 2164260936,
        label: 'オブジェクト > ライブペイント > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 2164260938,
        label: 'オブジェクト > ライブペイント > 隙間オプション...',
        placement: 'MenuBar',
        name: '隙間オプション...',
    },
    {
        id: 2164260940,
        label: 'オブジェクト > ライブペイント > 拡張',
        placement: 'MenuBar',
        name: '拡張',
    },
    {
        id: 2164260941,
        label: 'ウィンドウ > CC ライブラリ',
        placement: 'MenuBar',
        name: 'CC ライブラリ',
    },
    {
        id: 2164260943,
        label: 'ウィンドウ > Exchange でエクステンションを検索...',
        placement: 'MenuBar',
        name: 'Exchange でエクステンションを検索...',
    },
    {
        id: 2164260944,
        label: 'ウィンドウ > 分版プレビュー',
        placement: 'MenuBar',
        name: '分版プレビュー',
    },
    {
        id: 2164260945,
        label: 'ウィンドウ > リンク',
        placement: 'MenuBar',
        name: 'リンク',
    },
    {
        id: 2164260947,
        label: '編集 > オリジナルを編集',
        placement: 'MenuBar',
        name: 'オリジナルを編集',
    },
    {
        id: 2164260949,
        label: 'ウィンドウ > 書式 > 段落スタイル',
        placement: 'MenuBar',
        name: '段落スタイル',
    },
    {
        id: 2164260950,
        label: 'ウィンドウ > 書式 > 文字スタイル',
        placement: 'MenuBar',
        name: '文字スタイル',
    },
    {
        id: 2164260951,
        label: 'ウィンドウ > アートボード',
        placement: 'MenuBar',
        name: 'アートボード',
    },
    {
        id: 2164260953,
        label: 'オブジェクト > アートボード > すべてのアートボードを再配置',
        placement: 'MenuBar',
        name: 'すべてのアートボードを再配置',
    },
    {
        id: 2164260955,
        label: 'オブジェクト > アートボード > オブジェクト全体に合わせる',
        placement: 'MenuBar',
        name: 'オブジェクト全体に合わせる',
    },
    {
        id: 2164260956,
        label: 'オブジェクト > アートボード > 選択オブジェクトに合わせる',
        placement: 'MenuBar',
        name: '選択オブジェクトに合わせる',
    },
    {
        id: 2164260957,
        label: 'ウィンドウ > プロパティ',
        placement: 'MenuBar',
        name: 'プロパティ',
    },
    {
        id: 2164260958,
        label: 'ウィンドウ > ナビゲーター',
        placement: 'MenuBar',
        name: 'ナビゲーター',
    },
    {
        id: 2164260961,
        label: 'ウィンドウ > ワークスペース > Getting Started をリセット',
        placement: 'MenuBar',
        name: 'Getting Started をリセット',
    },
    {
        id: 2164260962,
        label: 'ウィンドウ > ワークスペース > 新規ワークスペース...',
        placement: 'MenuBar',
        name: '新規ワークスペース...',
    },
    {
        id: 2164260963,
        label: 'ウィンドウ > ワークスペース > ワークスペースの管理...',
        placement: 'MenuBar',
        name: 'ワークスペースの管理...',
    },
    {
        id: 2164260964,
        label: 'ウィンドウ > ワークスペース > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164260965,
        label: 'ウィンドウ > ワークスペース > レイアウト',
        placement: 'MenuBar',
        name: 'レイアウト',
    },
    {
        id: 2164260966,
        label: 'ウィンドウ > ワークスペース > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164260967,
        label: 'ウィンドウ > ワークスペース > ペイント',
        placement: 'MenuBar',
        name: 'ペイント',
    },
    {
        id: 2164260968,
        label: 'ウィンドウ > ワークスペース > 初期設定',
        placement: 'MenuBar',
        name: '初期設定',
    },
    {
        id: 2164260969,
        label: 'ウィンドウ > ワークスペース > プリントと校正',
        placement: 'MenuBar',
        name: 'プリントと校正',
    },
    {
        id: 2164260970,
        label: 'ウィンドウ > ワークスペース > 自動処理',
        placement: 'MenuBar',
        name: '自動処理',
    },
    {
        id: 2164260971,
        label: 'ウィンドウ > ワークスペース > 初期設定 (クラシック)',
        placement: 'MenuBar',
        name: '初期設定 (クラシック)',
    },
    {
        id: 2164260972,
        label: 'ウィンドウ > ワークスペース > トレース',
        placement: 'MenuBar',
        name: 'トレース',
    },
    {
        id: 2164260973,
        label: 'ウィンドウ > ワークスペース > テキスト編集',
        placement: 'MenuBar',
        name: 'テキスト編集',
    },
    {
        id: 2164260974,
        label: '書式 > 禁則処理設定...',
        placement: 'MenuBar',
        name: '禁則処理設定...',
    },
    {
        id: 2164260975,
        label: 'ウィンドウ > レイヤー',
        placement: 'MenuBar',
        name: 'レイヤー',
    },
    {
        id: 2164260978,
        label: '編集 > キーボードショートカット...',
        placement: 'MenuBar',
        name: 'キーボードショートカット...',
    },
    {
        id: 2164260979,
        label: 'ウィンドウ > グラフィックスタイル',
        placement: 'MenuBar',
        name: 'グラフィックスタイル',
    },
    {
        id: 2164260980,
        label: 'ウィンドウ > アピアランス',
        placement: 'MenuBar',
        name: 'アピアランス',
    },
    {
        id: 2164260986,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > 3D 効果',
        placement: 'MenuBar',
        name: '3D 効果',
    },
    {
        id: 2164260987,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > アーティスティック効果',
        placement: 'MenuBar',
        name: 'アーティスティック効果',
    },
    {
        id: 2164260988,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > イメージ効果',
        placement: 'MenuBar',
        name: 'イメージ効果',
    },
    {
        id: 2164260989,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > テクスチャ',
        placement: 'MenuBar',
        name: 'テクスチャ',
    },
    {
        id: 2164260990,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > ネオン効果',
        placement: 'MenuBar',
        name: 'ネオン効果',
    },
    {
        id: 2164260991,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > フォルスター_パターンスタイル',
        placement: 'MenuBar',
        name: 'フォルスター_パターンスタイル',
    },
    {
        id: 2164260992,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > ボタンとロールオーバー',
        placement: 'MenuBar',
        name: 'ボタンとロールオーバー',
    },
    {
        id: 2164260993,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > 光彩スタイル',
        placement: 'MenuBar',
        name: '光彩スタイル',
    },
    {
        id: 2164260994,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > 文字効果',
        placement: 'MenuBar',
        name: '文字効果',
    },
    {
        id: 2164260995,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > 落書き効果',
        placement: 'MenuBar',
        name: '落書き効果',
    },
    {
        id: 2164260996,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > 追加',
        placement: 'MenuBar',
        name: '追加',
    },
    {
        id: 2164260997,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > 追加の塗りブラシ',
        placement: 'MenuBar',
        name: '追加の塗りブラシ',
    },
    {
        id: 2164261000,
        label: 'ウィンドウ > グラフィックスタイルライブラリ > その他のライブラリ...',
        placement: 'MenuBar',
        name: 'その他のライブラリ...',
    },
    {
        id: 2164261001,
        label: '表示 > スマートガイド',
        placement: 'MenuBar',
        name: 'スマートガイド',
    },
    {
        id: 2164261002,
        label: 'ウィンドウ > シンボル',
        placement: 'MenuBar',
        name: 'シンボル',
    },
    {
        id: 2164261004,
        label: 'ウィンドウ > シンボルライブラリ > 3D シンボル',
        placement: 'MenuBar',
        name: '3D シンボル',
    },
    {
        id: 2164261005,
        label: 'ウィンドウ > シンボルライブラリ > Web アイコン',
        placement: 'MenuBar',
        name: 'Web アイコン',
    },
    {
        id: 2164261006,
        label: 'ウィンドウ > シンボルライブラリ > Web ボタンとバー',
        placement: 'MenuBar',
        name: 'Web ボタンとバー',
    },
    {
        id: 2164261007,
        label: 'ウィンドウ > シンボルライブラリ > お祝い',
        placement: 'MenuBar',
        name: 'お祝い',
    },
    {
        id: 2164261008,
        label: 'ウィンドウ > シンボルライブラリ > アートテクスチャ',
        placement: 'MenuBar',
        name: 'アートテクスチャ',
    },
    {
        id: 2164261009,
        label: 'ウィンドウ > シンボルライブラリ > コミュニケーション',
        placement: 'MenuBar',
        name: 'コミュニケーション',
    },
    {
        id: 2164261010,
        label: 'ウィンドウ > シンボルライブラリ > チャート',
        placement: 'MenuBar',
        name: 'チャート',
    },
    {
        id: 2164261011,
        label: 'ウィンドウ > シンボルライブラリ > ティキ',
        placement: 'MenuBar',
        name: 'ティキ',
    },
    {
        id: 2164261012,
        label: 'ウィンドウ > シンボルライブラリ > ドットパターンベクトルパック',
        placement: 'MenuBar',
        name: 'ドットパターンベクトルパック',
    },
    {
        id: 2164261013,
        label: 'ウィンドウ > シンボルライブラリ > ファッション',
        placement: 'MenuBar',
        name: 'ファッション',
    },
    {
        id: 2164261014,
        label: 'ウィンドウ > シンボルライブラリ > マッドサイエンス',
        placement: 'MenuBar',
        name: 'マッドサイエンス',
    },
    {
        id: 2164261015,
        label: 'ウィンドウ > シンボルライブラリ > モバイル',
        placement: 'MenuBar',
        name: 'モバイル',
    },
    {
        id: 2164261016,
        label: 'ウィンドウ > シンボルライブラリ > リーガルベクトルパック',
        placement: 'MenuBar',
        name: 'リーガルベクトルパック',
    },
    {
        id: 2164261017,
        label: 'ウィンドウ > シンボルライブラリ > レトロ',
        placement: 'MenuBar',
        name: 'レトロ',
    },
    {
        id: 2164261018,
        label: 'ウィンドウ > シンボルライブラリ > ロゴエレメント',
        placement: 'MenuBar',
        name: 'ロゴエレメント',
    },
    {
        id: 2164261019,
        label: 'ウィンドウ > シンボルライブラリ > 光彩フローチャート',
        placement: 'MenuBar',
        name: '光彩フローチャート',
    },
    {
        id: 2164261020,
        label: 'ウィンドウ > シンボルライブラリ > 光彩リボン',
        placement: 'MenuBar',
        name: '光彩リボン',
    },
    {
        id: 2164261021,
        label: 'ウィンドウ > シンボルライブラリ > 光彩組織図',
        placement: 'MenuBar',
        name: '光彩組織図',
    },
    {
        id: 2164261022,
        label: 'ウィンドウ > シンボルライブラリ > 原始的',
        placement: 'MenuBar',
        name: '原始的',
    },
    {
        id: 2164261023,
        label: 'ウィンドウ > シンボルライブラリ > 地図',
        placement: 'MenuBar',
        name: '地図',
    },
    {
        id: 2164261024,
        label: 'ウィンドウ > シンボルライブラリ > 家宝',
        placement: 'MenuBar',
        name: '家宝',
    },
    {
        id: 2164261025,
        label: 'ウィンドウ > シンボルライブラリ > 寿司',
        placement: 'MenuBar',
        name: '寿司',
    },
    {
        id: 2164261026,
        label: 'ウィンドウ > シンボルライブラリ > 明るいベクトルパック',
        placement: 'MenuBar',
        name: '明るいベクトルパック',
    },
    {
        id: 2164261027,
        label: 'ウィンドウ > シンボルライブラリ > 暗いベクトルパック',
        placement: 'MenuBar',
        name: '暗いベクトルパック',
    },
    {
        id: 2164261028,
        label: 'ウィンドウ > シンボルライブラリ > 矢印',
        placement: 'MenuBar',
        name: '矢印',
    },
    {
        id: 2164261029,
        label: 'ウィンドウ > シンボルライブラリ > 自然',
        placement: 'MenuBar',
        name: '自然',
    },
    {
        id: 2164261030,
        label: 'ウィンドウ > シンボルライブラリ > 花',
        placement: 'MenuBar',
        name: '花',
    },
    {
        id: 2164261031,
        label: 'ウィンドウ > シンボルライブラリ > 髪と毛皮',
        placement: 'MenuBar',
        name: '髪と毛皮',
    },
    {
        id: 2164261034,
        label: 'ウィンドウ > シンボルライブラリ > その他のライブラリ...',
        placement: 'MenuBar',
        name: 'その他のライブラリ...',
    },
    {
        id: 2164261036,
        label: 'ウィンドウ > ドキュメント情報',
        placement: 'MenuBar',
        name: 'ドキュメント情報',
    },
    {
        id: 2164261037,
        label: 'ウィンドウ > 分割・統合プレビュー',
        placement: 'MenuBar',
        name: '分割・統合プレビュー',
    },
    {
        id: 2164261038,
        label: 'ウィンドウ > ヒストリー',
        placement: 'MenuBar',
        name: 'ヒストリー',
    },
    {
        id: 2164261040,
        label: '書式 > 字形',
        placement: 'MenuBar',
        name: '字形',
    },
    {
        id: 2164261041,
        label: 'ウィンドウ > 書式 > 字形',
        placement: 'MenuBar',
        name: '字形',
    },
    {
        id: 2164261042,
        label: 'ウィンドウ > アクション',
        placement: 'MenuBar',
        name: 'アクション',
    },
    {
        id: 2164261044,
        label: 'ウィンドウ > カラー',
        placement: 'MenuBar',
        name: 'カラー',
    },
    {
        id: 2164261046,
        label: 'ウィンドウ > グラデーション',
        placement: 'MenuBar',
        name: 'グラデーション',
    },
    {
        id: 2164261047,
        label: 'ウィンドウ > 線',
        placement: 'MenuBar',
        name: '線',
    },
    {
        id: 2164261048,
        label: '表示 > グラデーションガイドを隠す',
        placement: 'MenuBar',
        name: 'グラデーションガイドを隠す',
    },
    {
        id: 2164261049,
        label: 'オブジェクト > パス > パスの方向反転',
        placement: 'MenuBar',
        name: 'パスの方向反転',
    },
    {
        id: 2164261050,
        label: 'ウィンドウ > 透明',
        placement: 'MenuBar',
        name: '透明',
    },
    {
        id: 2164261051,
        label: '表示 > 透明グリッドを表示',
        placement: 'MenuBar',
        name: '透明グリッドを表示',
    },
    {
        id: 2164261052,
        label: 'ウィンドウ > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 2164261054,
        label: 'オブジェクト > ブレンド > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 2164261055,
        label: 'オブジェクト > ブレンド > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 2164261057,
        label: 'オブジェクト > ブレンド > ブレンドオプション...',
        placement: 'MenuBar',
        name: 'ブレンドオプション...',
    },
    {
        id: 2164261059,
        label: 'オブジェクト > ブレンド > 拡張',
        placement: 'MenuBar',
        name: '拡張',
    },
    {
        id: 2164261061,
        label: 'オブジェクト > ブレンド > ブレンド軸を置き換え',
        placement: 'MenuBar',
        name: 'ブレンド軸を置き換え',
    },
    {
        id: 2164261062,
        label: 'オブジェクト > ブレンド > ブレンド軸を反転',
        placement: 'MenuBar',
        name: 'ブレンド軸を反転',
    },
    {
        id: 2164261063,
        label: 'オブジェクト > ブレンド > 前後を反転',
        placement: 'MenuBar',
        name: '前後を反転',
    },
    {
        id: 2164261065,
        label: '表示 > スライスを表示',
        placement: 'MenuBar',
        name: 'スライスを表示',
    },
    {
        id: 2164261066,
        label: '表示 > スライスをロック',
        placement: 'MenuBar',
        name: 'スライスをロック',
    },
    {
        id: 2164261069,
        label: 'オブジェクト > スライス > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 2164261070,
        label: 'オブジェクト > スライス > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 2164261072,
        label: 'オブジェクト > スライス > ガイドから作成',
        placement: 'MenuBar',
        name: 'ガイドから作成',
    },
    {
        id: 2164261073,
        label: 'オブジェクト > スライス > 選択範囲から作成',
        placement: 'MenuBar',
        name: '選択範囲から作成',
    },
    {
        id: 2164261075,
        label: 'オブジェクト > スライス > スライスを複製',
        placement: 'MenuBar',
        name: 'スライスを複製',
    },
    {
        id: 2164261076,
        label: 'オブジェクト > スライス > スライスを結合',
        placement: 'MenuBar',
        name: 'スライスを結合',
    },
    {
        id: 2164261077,
        label: 'オブジェクト > スライス > スライスを分割...',
        placement: 'MenuBar',
        name: 'スライスを分割...',
    },
    {
        id: 2164261078,
        label: 'オブジェクト > スライス > すべてを削除',
        placement: 'MenuBar',
        name: 'すべてを削除',
    },
    {
        id: 2164261080,
        label: 'オブジェクト > スライス > スライスオプション...',
        placement: 'MenuBar',
        name: 'スライスオプション...',
    },
    {
        id: 2164261082,
        label: 'オブジェクト > スライス > アートボードサイズでクリップ',
        placement: 'MenuBar',
        name: 'アートボードサイズでクリップ',
    },
    {
        id: 2164261084,
        label: '編集 > カラーを編集 > 前後にブレンド',
        placement: 'MenuBar',
        name: '前後にブレンド',
    },
    {
        id: 2164261085,
        label: '編集 > カラーを編集 > 左右にブレンド',
        placement: 'MenuBar',
        name: '左右にブレンド',
    },
    {
        id: 2164261086,
        label: '編集 > カラーを編集 > 上下にブレンド',
        placement: 'MenuBar',
        name: '上下にブレンド',
    },
    {
        id: 2164261087,
        label: '編集 > カラーを編集 > カラー反転',
        placement: 'MenuBar',
        name: 'カラー反転',
    },
    {
        id: 2164261088,
        label: '編集 > カラーを編集 > グレースケールに変換',
        placement: 'MenuBar',
        name: 'グレースケールに変換',
    },
    {
        id: 2164261089,
        label: '編集 > カラーを編集 > CMYK に変換',
        placement: 'MenuBar',
        name: 'CMYK に変換',
    },
    {
        id: 2164261090,
        label: '編集 > カラーを編集 > RGB に変換',
        placement: 'MenuBar',
        name: 'RGB に変換',
    },
    {
        id: 2164261091,
        label: '効果 > Illustrator 効果',
        placement: 'MenuBar',
        name: 'Illustrator 効果',
    },
    {
        id: 2164261094,
        label: '効果 > パスファインダー > 合体',
        placement: 'MenuBar',
        name: '合体',
    },
    {
        id: 2164261095,
        label: '効果 > パスファインダー > 交差',
        placement: 'MenuBar',
        name: '交差',
    },
    {
        id: 2164261096,
        label: '効果 > パスファインダー > 中マド',
        placement: 'MenuBar',
        name: '中マド',
    },
    {
        id: 2164261097,
        label: '効果 > パスファインダー > 前面オブジェクトで型抜き',
        placement: 'MenuBar',
        name: '前面オブジェクトで型抜き',
    },
    {
        id: 2164261098,
        label: '効果 > パスファインダー > 背面オブジェクトで型抜き',
        placement: 'MenuBar',
        name: '背面オブジェクトで型抜き',
    },
    {
        id: 2164261099,
        label: '効果 > パスファインダー > 分割',
        placement: 'MenuBar',
        name: '分割',
    },
    {
        id: 2164261100,
        label: '効果 > パスファインダー > 刈り込み',
        placement: 'MenuBar',
        name: '刈り込み',
    },
    {
        id: 2164261101,
        label: '効果 > パスファインダー > 合流',
        placement: 'MenuBar',
        name: '合流',
    },
    {
        id: 2164261102,
        label: '効果 > パスファインダー > 切り抜き',
        placement: 'MenuBar',
        name: '切り抜き',
    },
    {
        id: 2164261103,
        label: '効果 > パスファインダー > アウトライン',
        placement: 'MenuBar',
        name: 'アウトライン',
    },
    {
        id: 2164261104,
        label: '効果 > パスファインダー > 濃い混色',
        placement: 'MenuBar',
        name: '濃い混色',
    },
    {
        id: 2164261105,
        label: '効果 > パスファインダー > 薄い混色...',
        placement: 'MenuBar',
        name: '薄い混色...',
    },
    {
        id: 2164261106,
        label: '効果 > パスファインダー > トラップ...',
        placement: 'MenuBar',
        name: 'トラップ...',
    },
    {
        id: 2164261107,
        label: '選択 > 再選択',
        placement: 'MenuBar',
        name: '再選択',
    },
    {
        id: 2164261109,
        label: '選択 > 共通 > シェイプとテキスト',
        placement: 'MenuBar',
        name: 'シェイプとテキスト',
    },
    {
        id: 2164261110,
        label: '選択 > 共通 > テキスト',
        placement: 'MenuBar',
        name: 'テキスト',
    },
    {
        id: 2164261112,
        label: '選択 > 共通 > カラー (塗り)',
        placement: 'MenuBar',
        name: 'カラー (塗り)',
    },
    {
        id: 2164261113,
        label: '選択 > 共通 > グラフィックスタイル',
        placement: 'MenuBar',
        name: 'グラフィックスタイル',
    },
    {
        id: 2164261114,
        label: '選択 > 共通 > 塗りと線',
        placement: 'MenuBar',
        name: '塗りと線',
    },
    {
        id: 2164261115,
        label: '選択 > 共通 > カラー (線)',
        placement: 'MenuBar',
        name: 'カラー (線)',
    },
    {
        id: 2164261116,
        label: '選択 > 共通 > 線幅',
        placement: 'MenuBar',
        name: '線幅',
    },
    {
        id: 2164261117,
        label: '選択 > 共通 > 描画モード',
        placement: 'MenuBar',
        name: '描画モード',
    },
    {
        id: 2164261118,
        label: '選択 > 共通 > 不透明度',
        placement: 'MenuBar',
        name: '不透明度',
    },
    {
        id: 2164261119,
        label: '選択 > 共通 > シェイプ',
        placement: 'MenuBar',
        name: 'シェイプ',
    },
    {
        id: 2164261120,
        label: '選択 > 共通 > シンボルインスタンス',
        placement: 'MenuBar',
        name: 'シンボルインスタンス',
    },
    {
        id: 2164261121,
        label: '選択 > 共通 > 一連のリンクブロック',
        placement: 'MenuBar',
        name: '一連のリンクブロック',
    },
    {
        id: 2164261122,
        label: '選択 > 共通 > アピアランス',
        placement: 'MenuBar',
        name: 'アピアランス',
    },
    {
        id: 2164261123,
        label: '選択 > 共通 > アピアランス属性',
        placement: 'MenuBar',
        name: 'アピアランス属性',
    },
    {
        id: 2164261124,
        label: '選択 > 共通 > テキストカラー (塗り)',
        placement: 'MenuBar',
        name: 'テキストカラー (塗り)',
    },
    {
        id: 2164261125,
        label: '選択 > 共通 > テキストカラー (線)',
        placement: 'MenuBar',
        name: 'テキストカラー (線)',
    },
    {
        id: 2164261126,
        label: '選択 > 共通 > テキストカラー (塗りと線)',
        placement: 'MenuBar',
        name: 'テキストカラー (塗りと線)',
    },
    {
        id: 2164261127,
        label: '選択 > 共通 > フォントサイズ',
        placement: 'MenuBar',
        name: 'フォントサイズ',
    },
    {
        id: 2164261128,
        label: '選択 > 共通 > フォントファミリー',
        placement: 'MenuBar',
        name: 'フォントファミリー',
    },
    {
        id: 2164261129,
        label: '選択 > 共通 > フォントファミリー (スタイル)',
        placement: 'MenuBar',
        name: 'フォントファミリー (スタイル)',
    },
    {
        id: 2164261130,
        label: '選択 > 共通 > フォントファミリー (スタイルとサイズ)',
        placement: 'MenuBar',
        name: 'フォントファミリー (スタイルとサイズ)',
    },
    {
        id: 2164261131,
        label: '選択 > オブジェクト > 孤立点',
        placement: 'MenuBar',
        name: '孤立点',
    },
    {
        id: 2164261133,
        label: '選択 > オブジェクト > すべてのテキストオブジェクト',
        placement: 'MenuBar',
        name: 'すべてのテキストオブジェクト',
    },
    {
        id: 2164261134,
        label: '選択 > オブジェクト > ポイント文字オブジェクト',
        placement: 'MenuBar',
        name: 'ポイント文字オブジェクト',
    },
    {
        id: 2164261135,
        label: '選択 > オブジェクト > エリア内文字オブジェクト',
        placement: 'MenuBar',
        name: 'エリア内文字オブジェクト',
    },
    {
        id: 2164261136,
        label: '効果 > トリムマーク',
        placement: 'MenuBar',
        name: 'トリムマーク',
    },
    {
        id: 2164261137,
        label: 'オブジェクト > トリムマークを作成',
        placement: 'MenuBar',
        name: 'トリムマークを作成',
    },
    {
        id: 2164261138,
        label: 'オブジェクト > 分割・拡張...',
        placement: 'MenuBar',
        name: '分割・拡張...',
    },
    {
        id: 2164261140,
        label: '効果 > 3D とマテリアル > 押し出しとベベル...',
        placement: 'MenuBar',
        name: '押し出しとベベル...',
    },
    {
        id: 2164261141,
        label: '効果 > 3D とマテリアル > 回転体...',
        placement: 'MenuBar',
        name: '回転体...',
    },
    {
        id: 2164261142,
        label: '効果 > 3D とマテリアル > 膨張...',
        placement: 'MenuBar',
        name: '膨張...',
    },
    {
        id: 2164261143,
        label: '効果 > 3D とマテリアル > 回転...',
        placement: 'MenuBar',
        name: '回転...',
    },
    {
        id: 2164261144,
        label: '効果 > 3D とマテリアル > マテリアル...',
        placement: 'MenuBar',
        name: 'マテリアル...',
    },
    {
        id: 2164261146,
        label: '効果 > 3D とマテリアル > 3D (クラシック) > 押し出しとベベル (クラシック)...',
        placement: 'MenuBar',
        name: '押し出しとベベル (クラシック)...',
    },
    {
        id: 2164261147,
        label: '効果 > 3D とマテリアル > 3D (クラシック) > 回転体 (クラシック)...',
        placement: 'MenuBar',
        name: '回転体 (クラシック)...',
    },
    {
        id: 2164261148,
        label: '効果 > 3D とマテリアル > 3D (クラシック) > 回転 (クラシック)...',
        placement: 'MenuBar',
        name: '回転 (クラシック)...',
    },
    {
        id: 2164261149,
        label: 'ウィンドウ > SVG インタラクティビティ',
        placement: 'MenuBar',
        name: 'SVG インタラクティビティ',
    },
    {
        id: 2164261150,
        label: 'Illustrator > 環境設定 > パフォーマンス...',
        placement: 'MenuBar',
        name: 'パフォーマンス...',
    },
    {
        id: 2164261151,
        label: 'Illustrator > 環境設定 > ファイル管理...',
        placement: 'MenuBar',
        name: 'ファイル管理...',
    },
    {
        id: 2164261152,
        label: 'Illustrator > 環境設定 > クリップボードの処理...',
        placement: 'MenuBar',
        name: 'クリップボードの処理...',
    },
    {
        id: 2164261153,
        label: 'Illustrator > 環境設定 > ブラックのアピアランス...',
        placement: 'MenuBar',
        name: 'ブラックのアピアランス...',
    },
    {
        id: 2164261154,
        label: 'Illustrator > 環境設定 > デバイス...',
        placement: 'MenuBar',
        name: 'デバイス...',
    },
    {
        id: 2164261156,
        label: 'ウィンドウ > ツールバー > 基本',
        placement: 'MenuBar',
        name: '基本',
    },
    {
        id: 2164261157,
        label: 'ウィンドウ > ツールバー > 詳細',
        placement: 'MenuBar',
        name: '詳細',
    },
    {
        id: 2164261158,
        label: 'ウィンドウ > ツールバー > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261160,
        label: 'ウィンドウ > ツールバー > 新規ツールバー...',
        placement: 'MenuBar',
        name: '新規ツールバー...',
    },
    {
        id: 2164261161,
        label: 'ウィンドウ > ツールバー > ツールバーを管理...',
        placement: 'MenuBar',
        name: 'ツールバーを管理...',
    },
    {
        id: 2164261162,
        label: 'ウィンドウ > ブラシ',
        placement: 'MenuBar',
        name: 'ブラシ',
    },
    {
        id: 2164261163,
        label: '選択 > オブジェクト > ブラシストローク',
        placement: 'MenuBar',
        name: 'ブラシストローク',
    },
    {
        id: 2164261166,
        label: 'ウィンドウ > ブラシライブラリ > アート > アート_インク',
        placement: 'MenuBar',
        name: 'アート_インク',
    },
    {
        id: 2164261167,
        label: 'ウィンドウ > ブラシライブラリ > アート > アート_カリグラフィ',
        placement: 'MenuBar',
        name: 'アート_カリグラフィ',
    },
    {
        id: 2164261168,
        label: 'ウィンドウ > ブラシライブラリ > アート > アート_スクロールペン',
        placement: 'MenuBar',
        name: 'アート_スクロールペン',
    },
    {
        id: 2164261169,
        label: 'ウィンドウ > ブラシライブラリ > アート > アート_ペイントブラシ',
        placement: 'MenuBar',
        name: 'アート_ペイントブラシ',
    },
    {
        id: 2164261170,
        label: 'ウィンドウ > ブラシライブラリ > アート > アート_木炭・鉛筆',
        placement: 'MenuBar',
        name: 'アート_木炭・鉛筆',
    },
    {
        id: 2164261171,
        label: 'ウィンドウ > ブラシライブラリ > アート > アート_水彩',
        placement: 'MenuBar',
        name: 'アート_水彩',
    },
    {
        id: 2164261173,
        label: 'ウィンドウ > ブラシライブラリ > ベクトルパック > グランジブラシベクトルパック',
        placement: 'MenuBar',
        name: 'グランジブラシベクトルパック',
    },
    {
        id: 2164261174,
        label: 'ウィンドウ > ブラシライブラリ > ベクトルパック > 手書きブラシベクトルパック',
        placement: 'MenuBar',
        name: '手書きブラシベクトルパック',
    },
    {
        id: 2164261176,
        label: 'ウィンドウ > ブラシライブラリ > ボーダー > ボーダー_デコレーション',
        placement: 'MenuBar',
        name: 'ボーダー_デコレーション',
    },
    {
        id: 2164261177,
        label: 'ウィンドウ > ブラシライブラリ > ボーダー > ボーダー_ノベルティ',
        placement: 'MenuBar',
        name: 'ボーダー_ノベルティ',
    },
    {
        id: 2164261178,
        label: 'ウィンドウ > ブラシライブラリ > ボーダー > ボーダー_プリミティブ',
        placement: 'MenuBar',
        name: 'ボーダー_プリミティブ',
    },
    {
        id: 2164261179,
        label: 'ウィンドウ > ブラシライブラリ > ボーダー > ボーダー_フレーム',
        placement: 'MenuBar',
        name: 'ボーダー_フレーム',
    },
    {
        id: 2164261180,
        label: 'ウィンドウ > ブラシライブラリ > ボーダー > ボーダー_ライン',
        placement: 'MenuBar',
        name: 'ボーダー_ライン',
    },
    {
        id: 2164261181,
        label: 'ウィンドウ > ブラシライブラリ > ボーダー > ボーダー_幾何学模様',
        placement: 'MenuBar',
        name: 'ボーダー_幾何学模様',
    },
    {
        id: 2164261182,
        label: 'ウィンドウ > ブラシライブラリ > ボーダー > ボーダー_破線',
        placement: 'MenuBar',
        name: 'ボーダー_破線',
    },
    {
        id: 2164261184,
        label: 'ウィンドウ > ブラシライブラリ > ワコム 6D ブラシ > 6d アートペンブラシ',
        placement: 'MenuBar',
        name: '6d アートペンブラシ',
    },
    {
        id: 2164261186,
        label: 'ウィンドウ > ブラシライブラリ > 画像ブラシ > 画像ブラシライブラリ',
        placement: 'MenuBar',
        name: '画像ブラシライブラリ',
    },
    {
        id: 2164261188,
        label: 'ウィンドウ > ブラシライブラリ > 矢印 > パターン矢印',
        placement: 'MenuBar',
        name: 'パターン矢印',
    },
    {
        id: 2164261189,
        label: 'ウィンドウ > ブラシライブラリ > 矢印 > 矢印_標準',
        placement: 'MenuBar',
        name: '矢印_標準',
    },
    {
        id: 2164261190,
        label: 'ウィンドウ > ブラシライブラリ > 矢印 > 矢印_特殊',
        placement: 'MenuBar',
        name: '矢印_特殊',
    },
    {
        id: 2164261192,
        label: 'ウィンドウ > ブラシライブラリ > 絵筆ブラシ > 絵筆ブラシライブラリ',
        placement: 'MenuBar',
        name: '絵筆ブラシライブラリ',
    },
    {
        id: 2164261194,
        label: 'ウィンドウ > ブラシライブラリ > 装飾 > 装飾_バナーとシール',
        placement: 'MenuBar',
        name: '装飾_バナーとシール',
    },
    {
        id: 2164261195,
        label: 'ウィンドウ > ブラシライブラリ > 装飾 > 装飾_分割線',
        placement: 'MenuBar',
        name: '装飾_分割線',
    },
    {
        id: 2164261196,
        label: 'ウィンドウ > ブラシライブラリ > 装飾 > 装飾_散布',
        placement: 'MenuBar',
        name: '装飾_散布',
    },
    {
        id: 2164261197,
        label: 'ウィンドウ > ブラシライブラリ > 装飾 > 豪華なカールブラシとフローラルブラシのセット',
        placement: 'MenuBar',
        name: '豪華なカールブラシとフローラルブラシのセット',
    },
    {
        id: 2164261200,
        label: 'ウィンドウ > ブラシライブラリ > その他のライブラリ...',
        placement: 'MenuBar',
        name: 'その他のライブラリ...',
    },
    {
        id: 2164261201,
        label: 'ウィンドウ > パスファインダー',
        placement: 'MenuBar',
        name: 'パスファインダー',
    },
    {
        id: 2164261202,
        label: 'ウィンドウ > 変数',
        placement: 'MenuBar',
        name: '変数',
    },
    {
        id: 2164261204,
        label: 'ウィンドウ > 自動選択',
        placement: 'MenuBar',
        name: '自動選択',
    },
    {
        id: 2164261205,
        label: 'オブジェクト > パス > 背面のオブジェクトを分割',
        placement: 'MenuBar',
        name: '背面のオブジェクトを分割',
    },
    {
        id: 2164261206,
        label: '選択 > オブジェクト > 絵筆ブラシストローク',
        placement: 'MenuBar',
        name: '絵筆ブラシストローク',
    },
    {
        id: 2164261209,
        label: 'オブジェクト > 変形 > バウンディングボックスのリセット',
        placement: 'MenuBar',
        name: 'バウンディングボックスのリセット',
    },
    {
        id: 2164261210,
        label: '表示 > バウンディングボックスを隠す',
        placement: 'MenuBar',
        name: 'バウンディングボックスを隠す',
    },
    {
        id: 2164261211,
        label: 'オブジェクト > パス > 単純化...',
        placement: 'MenuBar',
        name: '単純化...',
    },
    {
        id: 2164261212,
        label: 'オブジェクト > パス > スムーズ...',
        placement: 'MenuBar',
        name: 'スムーズ...',
    },
    {
        id: 2164261213,
        label: 'ウィンドウ > スウォッチ',
        placement: 'MenuBar',
        name: 'スウォッチ',
    },
    {
        id: 2164261216,
        label: 'ウィンドウ > パターンオプション',
        placement: 'MenuBar',
        name: 'パターンオプション',
    },
    {
        id: 2164261217,
        label: 'ウィンドウ > 生成パターン (Beta)',
        placement: 'MenuBar',
        name: '生成パターン (Beta)',
    },
    {
        id: 2164261219,
        label: 'オブジェクト > パターン > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 2164261221,
        label: 'オブジェクト > パターン > パターンを編集',
        placement: 'MenuBar',
        name: 'パターンを編集',
    },
    {
        id: 2164261222,
        label: 'オブジェクト > パターン > タイルの境界線カラー...',
        placement: 'MenuBar',
        name: 'タイルの境界線カラー...',
    },
    {
        id: 2164261224,
        label: 'オブジェクト > パターン > 生成パターン (Beta)',
        placement: 'MenuBar',
        name: '生成パターン (Beta)',
    },
    {
        id: 2164261225,
        label: 'ウィンドウ > スウォッチライブラリ > VisiBone2',
        placement: 'MenuBar',
        name: 'VisiBone2',
    },
    {
        id: 2164261226,
        label: 'ウィンドウ > スウォッチライブラリ > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261227,
        label: 'ウィンドウ > スウォッチライブラリ > お祝い',
        placement: 'MenuBar',
        name: 'お祝い',
    },
    {
        id: 2164261228,
        label: 'ウィンドウ > スウォッチライブラリ > アースカラー',
        placement: 'MenuBar',
        name: 'アースカラー',
    },
    {
        id: 2164261230,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > ANPA カラー',
        placement: 'MenuBar',
        name: 'ANPA カラー',
    },
    {
        id: 2164261231,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > DIC カラーガイド',
        placement: 'MenuBar',
        name: 'DIC カラーガイド',
    },
    {
        id: 2164261232,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > FOCOLTONE',
        placement: 'MenuBar',
        name: 'FOCOLTONE',
    },
    {
        id: 2164261233,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > HKS E プロセスカラー',
        placement: 'MenuBar',
        name: 'HKS E プロセスカラー',
    },
    {
        id: 2164261234,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > HKS E',
        placement: 'MenuBar',
        name: 'HKS E',
    },
    {
        id: 2164261235,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > HKS K プロセスカラー',
        placement: 'MenuBar',
        name: 'HKS K プロセスカラー',
    },
    {
        id: 2164261236,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > HKS K',
        placement: 'MenuBar',
        name: 'HKS K',
    },
    {
        id: 2164261237,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > HKS N プロセスカラー',
        placement: 'MenuBar',
        name: 'HKS N プロセスカラー',
    },
    {
        id: 2164261238,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > HKS N',
        placement: 'MenuBar',
        name: 'HKS N',
    },
    {
        id: 2164261239,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > HKS Z プロセスカラー',
        placement: 'MenuBar',
        name: 'HKS Z プロセスカラー',
    },
    {
        id: 2164261240,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > HKS Z',
        placement: 'MenuBar',
        name: 'HKS Z',
    },
    {
        id: 2164261241,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > TOYO 94 COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO 94 COLOR FINDER',
    },
    {
        id: 2164261242,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > TOYO COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO COLOR FINDER',
    },
    {
        id: 2164261243,
        label: 'ウィンドウ > スウォッチライブラリ > カラーブック > TRUMATCH',
        placement: 'MenuBar',
        name: 'TRUMATCH',
    },
    {
        id: 2164261245,
        label: 'ウィンドウ > スウォッチライブラリ > カラー特性 > ソフト',
        placement: 'MenuBar',
        name: 'ソフト',
    },
    {
        id: 2164261246,
        label: 'ウィンドウ > スウォッチライブラリ > カラー特性 > ダーク',
        placement: 'MenuBar',
        name: 'ダーク',
    },
    {
        id: 2164261247,
        label: 'ウィンドウ > スウォッチライブラリ > カラー特性 > ブライト',
        placement: 'MenuBar',
        name: 'ブライト',
    },
    {
        id: 2164261248,
        label: 'ウィンドウ > スウォッチライブラリ > カラー特性 > ライト',
        placement: 'MenuBar',
        name: 'ライト',
    },
    {
        id: 2164261249,
        label: 'ウィンドウ > スウォッチライブラリ > カラー特性 > 低彩度',
        placement: 'MenuBar',
        name: '低彩度',
    },
    {
        id: 2164261250,
        label: 'ウィンドウ > スウォッチライブラリ > カラー特性 > 寒色',
        placement: 'MenuBar',
        name: '寒色',
    },
    {
        id: 2164261251,
        label: 'ウィンドウ > スウォッチライブラリ > カラー特性 > 暖色',
        placement: 'MenuBar',
        name: '暖色',
    },
    {
        id: 2164261252,
        label: 'ウィンドウ > スウォッチライブラリ > カラー特性 > 高彩度',
        placement: 'MenuBar',
        name: '高彩度',
    },
    {
        id: 2164261253,
        label: 'ウィンドウ > スウォッチライブラリ > キッズ',
        placement: 'MenuBar',
        name: 'キッズ',
    },
    {
        id: 2164261255,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > アーストーン',
        placement: 'MenuBar',
        name: 'アーストーン',
    },
    {
        id: 2164261256,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > カラーコンビネーション',
        placement: 'MenuBar',
        name: 'カラーコンビネーション',
    },
    {
        id: 2164261257,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > カラーハーモニー',
        placement: 'MenuBar',
        name: 'カラーハーモニー',
    },
    {
        id: 2164261258,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > スウォッチ (明)',
        placement: 'MenuBar',
        name: 'スウォッチ (明)',
    },
    {
        id: 2164261259,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > スキントーン',
        placement: 'MenuBar',
        name: 'スキントーン',
    },
    {
        id: 2164261260,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > スペクトル',
        placement: 'MenuBar',
        name: 'スペクトル',
    },
    {
        id: 2164261261,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > パステル',
        placement: 'MenuBar',
        name: 'パステル',
    },
    {
        id: 2164261262,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > ビネット',
        placement: 'MenuBar',
        name: 'ビネット',
    },
    {
        id: 2164261263,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > フェード',
        placement: 'MenuBar',
        name: 'フェード',
    },
    {
        id: 2164261264,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > メタル',
        placement: 'MenuBar',
        name: 'メタル',
    },
    {
        id: 2164261265,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 中間色',
        placement: 'MenuBar',
        name: '中間色',
    },
    {
        id: 2164261266,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 円形',
        placement: 'MenuBar',
        name: '円形',
    },
    {
        id: 2164261267,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 季節',
        placement: 'MenuBar',
        name: '季節',
    },
    {
        id: 2164261268,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 宝石とジュエリー',
        placement: 'MenuBar',
        name: '宝石とジュエリー',
    },
    {
        id: 2164261269,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 木目',
        placement: 'MenuBar',
        name: '木目',
    },
    {
        id: 2164261270,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 果物と野菜',
        placement: 'MenuBar',
        name: '果物と野菜',
    },
    {
        id: 2164261271,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 植物',
        placement: 'MenuBar',
        name: '植物',
    },
    {
        id: 2164261272,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 水',
        placement: 'MenuBar',
        name: '水',
    },
    {
        id: 2164261273,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 石とレンガ',
        placement: 'MenuBar',
        name: '石とレンガ',
    },
    {
        id: 2164261274,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 空',
        placement: 'MenuBar',
        name: '空',
    },
    {
        id: 2164261275,
        label: 'ウィンドウ > スウォッチライブラリ > グラデーション > 色合いと陰影',
        placement: 'MenuBar',
        name: '色合いと陰影',
    },
    {
        id: 2164261276,
        label: 'ウィンドウ > スウォッチライブラリ > コーポレート',
        placement: 'MenuBar',
        name: 'コーポレート',
    },
    {
        id: 2164261277,
        label: 'ウィンドウ > スウォッチライブラリ > システム (Macintosh)',
        placement: 'MenuBar',
        name: 'システム (Macintosh)',
    },
    {
        id: 2164261278,
        label: 'ウィンドウ > スウォッチライブラリ > システム (Windows)',
        placement: 'MenuBar',
        name: 'システム (Windows)',
    },
    {
        id: 2164261279,
        label: 'ウィンドウ > スウォッチライブラリ > スキントーン',
        placement: 'MenuBar',
        name: 'スキントーン',
    },
    {
        id: 2164261280,
        label: 'ウィンドウ > スウォッチライブラリ > テキスタイル',
        placement: 'MenuBar',
        name: 'テキスタイル',
    },
    {
        id: 2164261281,
        label: 'ウィンドウ > スウォッチライブラリ > ニュートラル',
        placement: 'MenuBar',
        name: 'ニュートラル',
    },
    {
        id: 2164261284,
        label: 'ウィンドウ > スウォッチライブラリ > パターン > ベーシック > ベーシック_テクスチャ',
        placement: 'MenuBar',
        name: 'ベーシック_テクスチャ',
    },
    {
        id: 2164261285,
        label: 'ウィンドウ > スウォッチライブラリ > パターン > ベーシック > ベーシック_ライン',
        placement: 'MenuBar',
        name: 'ベーシック_ライン',
    },
    {
        id: 2164261286,
        label: 'ウィンドウ > スウォッチライブラリ > パターン > ベーシック > ベーシック_点',
        placement: 'MenuBar',
        name: 'ベーシック_点',
    },
    {
        id: 2164261288,
        label: 'ウィンドウ > スウォッチライブラリ > パターン > 自然 > 自然_アニマルスキン',
        placement: 'MenuBar',
        name: '自然_アニマルスキン',
    },
    {
        id: 2164261289,
        label: 'ウィンドウ > スウォッチライブラリ > パターン > 自然 > 自然_植物',
        placement: 'MenuBar',
        name: '自然_植物',
    },
    {
        id: 2164261291,
        label: 'ウィンドウ > スウォッチライブラリ > パターン > 装飾 > フォルスター_パターン',
        placement: 'MenuBar',
        name: 'フォルスター_パターン',
    },
    {
        id: 2164261292,
        label: 'ウィンドウ > スウォッチライブラリ > パターン > 装飾 > 装飾_ レガシー',
        placement: 'MenuBar',
        name: '装飾_ レガシー',
    },
    {
        id: 2164261294,
        label: 'ウィンドウ > スウォッチライブラリ > フード > アイスクリーム',
        placement: 'MenuBar',
        name: 'アイスクリーム',
    },
    {
        id: 2164261295,
        label: 'ウィンドウ > スウォッチライブラリ > フード > スウィーツ',
        placement: 'MenuBar',
        name: 'スウィーツ',
    },
    {
        id: 2164261296,
        label: 'ウィンドウ > スウォッチライブラリ > フード > ドリンク',
        placement: 'MenuBar',
        name: 'ドリンク',
    },
    {
        id: 2164261297,
        label: 'ウィンドウ > スウォッチライブラリ > フード > フルーツ',
        placement: 'MenuBar',
        name: 'フルーツ',
    },
    {
        id: 2164261298,
        label: 'ウィンドウ > スウォッチライブラリ > フード > ベジタブル',
        placement: 'MenuBar',
        name: 'ベジタブル',
    },
    {
        id: 2164261300,
        label: 'ウィンドウ > スウォッチライブラリ > 初期設定スウォッチ > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261301,
        label: 'ウィンドウ > スウォッチライブラリ > 初期設定スウォッチ > デバイス',
        placement: 'MenuBar',
        name: 'デバイス',
    },
    {
        id: 2164261302,
        label: 'ウィンドウ > スウォッチライブラリ > 初期設定スウォッチ > ビデオとフィルム',
        placement: 'MenuBar',
        name: 'ビデオとフィルム',
    },
    {
        id: 2164261303,
        label: 'ウィンドウ > スウォッチライブラリ > 初期設定スウォッチ > プリント',
        placement: 'MenuBar',
        name: 'プリント',
    },
    {
        id: 2164261304,
        label: 'ウィンドウ > スウォッチライブラリ > 初期設定スウォッチ > 基本 RGB',
        placement: 'MenuBar',
        name: '基本 RGB',
    },
    {
        id: 2164261306,
        label: 'ウィンドウ > スウォッチライブラリ > 美術史 > バロック',
        placement: 'MenuBar',
        name: 'バロック',
    },
    {
        id: 2164261307,
        label: 'ウィンドウ > スウォッチライブラリ > 美術史 > ポップアート',
        placement: 'MenuBar',
        name: 'ポップアート',
    },
    {
        id: 2164261308,
        label: 'ウィンドウ > スウォッチライブラリ > 美術史 > ルネサンス',
        placement: 'MenuBar',
        name: 'ルネサンス',
    },
    {
        id: 2164261309,
        label: 'ウィンドウ > スウォッチライブラリ > 美術史 > ロシアポスター',
        placement: 'MenuBar',
        name: 'ロシアポスター',
    },
    {
        id: 2164261310,
        label: 'ウィンドウ > スウォッチライブラリ > 美術史 > 中世',
        placement: 'MenuBar',
        name: '中世',
    },
    {
        id: 2164261311,
        label: 'ウィンドウ > スウォッチライブラリ > 美術史 > 先史時代',
        placement: 'MenuBar',
        name: '先史時代',
    },
    {
        id: 2164261312,
        label: 'ウィンドウ > スウォッチライブラリ > 美術史 > 印象派',
        placement: 'MenuBar',
        name: '印象派',
    },
    {
        id: 2164261313,
        label: 'ウィンドウ > スウォッチライブラリ > 美術史 > 古代',
        placement: 'MenuBar',
        name: '古代',
    },
    {
        id: 2164261315,
        label: 'ウィンドウ > スウォッチライブラリ > 自然 > 季節',
        placement: 'MenuBar',
        name: '季節',
    },
    {
        id: 2164261316,
        label: 'ウィンドウ > スウォッチライブラリ > 自然 > 植物',
        placement: 'MenuBar',
        name: '植物',
    },
    {
        id: 2164261317,
        label: 'ウィンドウ > スウォッチライブラリ > 自然 > 海岸',
        placement: 'MenuBar',
        name: '海岸',
    },
    {
        id: 2164261318,
        label: 'ウィンドウ > スウォッチライブラリ > 自然 > 石とレンガ',
        placement: 'MenuBar',
        name: '石とレンガ',
    },
    {
        id: 2164261319,
        label: 'ウィンドウ > スウォッチライブラリ > 自然 > 花',
        placement: 'MenuBar',
        name: '花',
    },
    {
        id: 2164261320,
        label: 'ウィンドウ > スウォッチライブラリ > 自然 > 風景',
        placement: 'MenuBar',
        name: '風景',
    },
    {
        id: 2164261322,
        label: 'ウィンドウ > スウォッチライブラリ > 自然科学 > テトラード',
        placement: 'MenuBar',
        name: 'テトラード',
    },
    {
        id: 2164261323,
        label: 'ウィンドウ > スウォッチライブラリ > 自然科学 > トライアド',
        placement: 'MenuBar',
        name: 'トライアド',
    },
    {
        id: 2164261324,
        label: 'ウィンドウ > スウォッチライブラリ > 自然科学 > 分裂補色',
        placement: 'MenuBar',
        name: '分裂補色',
    },
    {
        id: 2164261325,
        label: 'ウィンドウ > スウォッチライブラリ > 自然科学 > 補色',
        placement: 'MenuBar',
        name: '補色',
    },
    {
        id: 2164261326,
        label: 'ウィンドウ > スウォッチライブラリ > 自然科学 > 類似色',
        placement: 'MenuBar',
        name: '類似色',
    },
    {
        id: 2164261327,
        label: 'ウィンドウ > スウォッチライブラリ > 金属',
        placement: 'MenuBar',
        name: '金属',
    },
    {
        id: 2164261330,
        label: 'ウィンドウ > スウォッチライブラリ > その他のライブラリ...',
        placement: 'MenuBar',
        name: 'その他のライブラリ...',
    },
    {
        id: 2164261331,
        label: 'ウィンドウ > カラーガイド',
        placement: 'MenuBar',
        name: 'カラーガイド',
    },
    {
        id: 2164261332,
        label: '編集 > カラーを編集 > オブジェクトを再配色...',
        placement: 'MenuBar',
        name: 'オブジェクトを再配色...',
    },
    {
        id: 2164261335,
        label: '編集 > カラーを編集 > 生成再配色',
        placement: 'MenuBar',
        name: '生成再配色',
    },
    {
        id: 2164261337,
        label: '編集 > カラーを編集 > プリセットで再配色 > カラーライブラリ...',
        placement: 'MenuBar',
        name: 'カラーライブラリ...',
    },
    {
        id: 2164261338,
        label: '編集 > カラーを編集 > プリセットで再配色 > 単色',
        placement: 'MenuBar',
        name: '単色',
    },
    {
        id: 2164261339,
        label: '編集 > カラーを編集 > プリセットで再配色 > 2 色',
        placement: 'MenuBar',
        name: '2 色',
    },
    {
        id: 2164261340,
        label: '編集 > カラーを編集 > プリセットで再配色 > 3 色',
        placement: 'MenuBar',
        name: '3 色',
    },
    {
        id: 2164261341,
        label: '編集 > カラーを編集 > プリセットで再配色 > カラーハーモニー',
        placement: 'MenuBar',
        name: 'カラーハーモニー',
    },
    {
        id: 2164261342,
        label: 'ウィンドウ > コントロール',
        placement: 'MenuBar',
        name: 'コントロール',
    },
    {
        id: 2164261343,
        label: 'ウィンドウ > コンテキストタスクバー',
        placement: 'MenuBar',
        name: 'コンテキストタスクバー',
    },
    {
        id: 2164261345,
        label: 'オブジェクト > クロスと重なり > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 2164261346,
        label: 'オブジェクト > クロスと重なり > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 2164261347,
        label: 'オブジェクト > クロスと重なり > 編集',
        placement: 'MenuBar',
        name: '編集',
    },
    {
        id: 2164261348,
        label: 'ウィンドウ > 整列',
        placement: 'MenuBar',
        name: '整列',
    },
    {
        id: 2164261350,
        label: 'オブジェクト > 整列 > 水平方向左に整列',
        placement: 'MenuBar',
        name: '水平方向左に整列',
    },
    {
        id: 2164261351,
        label: 'オブジェクト > 整列 > 水平方向中央に整列',
        placement: 'MenuBar',
        name: '水平方向中央に整列',
    },
    {
        id: 2164261352,
        label: 'オブジェクト > 整列 > 水平方向右に整列',
        placement: 'MenuBar',
        name: '水平方向右に整列',
    },
    {
        id: 2164261353,
        label: 'オブジェクト > 整列 > 垂直方向上に整列',
        placement: 'MenuBar',
        name: '垂直方向上に整列',
    },
    {
        id: 2164261354,
        label: 'オブジェクト > 整列 > 垂直方向中央に整列',
        placement: 'MenuBar',
        name: '垂直方向中央に整列',
    },
    {
        id: 2164261355,
        label: 'オブジェクト > 整列 > 垂直方向下に整列',
        placement: 'MenuBar',
        name: '垂直方向下に整列',
    },
    {
        id: 2164261357,
        label: 'オブジェクト > 分布 > 垂直方向上に分布',
        placement: 'MenuBar',
        name: '垂直方向上に分布',
    },
    {
        id: 2164261358,
        label: 'オブジェクト > 分布 > 垂直方向中央に分布',
        placement: 'MenuBar',
        name: '垂直方向中央に分布',
    },
    {
        id: 2164261359,
        label: 'オブジェクト > 分布 > 垂直方向下に分布',
        placement: 'MenuBar',
        name: '垂直方向下に分布',
    },
    {
        id: 2164261360,
        label: 'オブジェクト > 分布 > 水平方向左に分布',
        placement: 'MenuBar',
        name: '水平方向左に分布',
    },
    {
        id: 2164261361,
        label: 'オブジェクト > 分布 > 水平方向中央に分布',
        placement: 'MenuBar',
        name: '水平方向中央に分布',
    },
    {
        id: 2164261362,
        label: 'オブジェクト > 分布 > 水平方向右に分布',
        placement: 'MenuBar',
        name: '水平方向右に分布',
    },
    {
        id: 2164261363,
        label: 'ウィンドウ > 変形',
        placement: 'MenuBar',
        name: '変形',
    },
    {
        id: 2164261365,
        label: 'オブジェクト > リピート > ラジアル',
        placement: 'MenuBar',
        name: 'ラジアル',
    },
    {
        id: 2164261366,
        label: 'オブジェクト > リピート > グリッド',
        placement: 'MenuBar',
        name: 'グリッド',
    },
    {
        id: 2164261367,
        label: 'オブジェクト > リピート > ミラー',
        placement: 'MenuBar',
        name: 'ミラー',
    },
    {
        id: 2164261369,
        label: 'オブジェクト > リピート > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 2164261370,
        label: 'オブジェクト > リピート > オプション...',
        placement: 'MenuBar',
        name: 'オプション...',
    },
    {
        id: 2164261372,
        label: 'オブジェクト > パス上オブジェクト > アタッチ...',
        placement: 'MenuBar',
        name: 'アタッチ...',
    },
    {
        id: 2164261373,
        label: 'オブジェクト > パス上オブジェクト > オプション...',
        placement: 'MenuBar',
        name: 'オプション...',
    },
    {
        id: 2164261374,
        label: 'オブジェクト > パス上オブジェクト > 拡張',
        placement: 'MenuBar',
        name: '拡張',
    },
    {
        id: 2164261376,
        label: 'オブジェクト > モックアップ > モックアップをプレビュー',
        placement: 'MenuBar',
        name: 'モックアップをプレビュー',
    },
    {
        id: 2164261377,
        label: 'オブジェクト > モックアップ > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 2164261378,
        label: 'オブジェクト > モックアップ > 編集',
        placement: 'MenuBar',
        name: '編集',
    },
    {
        id: 2164261379,
        label: 'ウィンドウ > 属性',
        placement: 'MenuBar',
        name: '属性',
    },
    {
        id: 2164261380,
        label: '書式 > Adobe Fonts から追加...',
        placement: 'MenuBar',
        name: 'Adobe Fonts から追加...',
    },
    {
        id: 2164261381,
        label: '書式 > 環境にないフォントを解決する...',
        placement: 'MenuBar',
        name: '環境にないフォントを解決する...',
    },
    {
        id: 2164261382,
        label: 'ヘルプ > サポートコミュニティ',
        placement: 'MenuBar',
        name: 'サポートコミュニティ',
    },
    {
        id: 2164261383,
        label: 'ヘルプ > バグを送信／機能改善のリクエスト...',
        placement: 'MenuBar',
        name: 'バグを送信／機能改善のリクエスト...',
    },
    {
        id: 2164261385,
        label: 'オブジェクト > ピクセルグリッドに最適化',
        placement: 'MenuBar',
        name: 'ピクセルグリッドに最適化',
    },
    {
        id: 2164261386,
        label: 'ウィンドウ > 書式 > 文字組み更新',
        placement: 'MenuBar',
        name: '文字組み更新',
    },
    {
        id: 2164261387,
        label: 'ヘルプ > 生成 AI ユーザーガイドライン',
        placement: 'MenuBar',
        name: '生成 AI ユーザーガイドライン',
    },
    {
        id: 2164261389,
        label: '編集 > 透明の分割・統合プリセット...',
        placement: 'MenuBar',
        name: '透明の分割・統合プリセット...',
    },
    {
        id: 2164261391,
        label: 'オブジェクト > 透明部分を分割・統合...',
        placement: 'MenuBar',
        name: '透明部分を分割・統合...',
    },
    {
        id: 2164261393,
        label: 'オブジェクト > シェイプ > シェイプに変換',
        placement: 'MenuBar',
        name: 'シェイプに変換',
    },
    {
        id: 2164261394,
        label: 'オブジェクト > シェイプ > シェイプを拡張',
        placement: 'MenuBar',
        name: 'シェイプを拡張',
    },
    {
        id: 2164261395,
        label: 'ウィンドウ > モックアップ',
        placement: 'MenuBar',
        name: 'モックアップ',
    },
    {
        id: 2164261396,
        label: 'ウィンドウ > 生成されたバリエーション',
        placement: 'MenuBar',
        name: '生成されたバリエーション',
    },
    {
        id: 2164261397,
        label: 'オブジェクト > 生成ベクター (Beta)...',
        placement: 'MenuBar',
        name: '生成ベクター (Beta)...',
    },
    {
        id: 2164261398,
        label: 'ファイル > 生成ベクター (Beta)...',
        placement: 'MenuBar',
        name: '生成ベクター (Beta)...',
    },
    {
        id: 2164261399,
        label: 'オブジェクト > 生成塗りつぶし (シェイプ) (Beta)...',
        placement: 'MenuBar',
        name: '生成塗りつぶし (シェイプ) (Beta)...',
    },
    {
        id: 2164261400,
        label: 'ウィンドウ > 3D とマテリアル',
        placement: 'MenuBar',
        name: '3D とマテリアル',
    },
    {
        id: 2164261401,
        label: 'ウィンドウ > 画像トレース',
        placement: 'MenuBar',
        name: '画像トレース',
    },
    {
        id: 2164261403,
        label: 'オブジェクト > 画像トレース > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 2164261404,
        label: 'オブジェクト > 画像トレース > 作成して拡張',
        placement: 'MenuBar',
        name: '作成して拡張',
    },
    {
        id: 2164261405,
        label: 'オブジェクト > 画像トレース > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 2164261407,
        label: 'オブジェクト > 画像トレース > 拡張',
        placement: 'MenuBar',
        name: '拡張',
    },
    {
        id: 2164261408,
        label: 'ウィンドウ > CSS プロパティ (非推奨)',
        placement: 'MenuBar',
        name: 'CSS プロパティ (非推奨)',
    },
    {
        id: 2164261410,
        label: '効果 > パス > オブジェクトのアウトライン',
        placement: 'MenuBar',
        name: 'オブジェクトのアウトライン',
    },
    {
        id: 2164261411,
        label: '編集 > Adobe PDF プリセット...',
        placement: 'MenuBar',
        name: 'Adobe PDF プリセット...',
    },
    {
        id: 2164261412,
        label: 'ウィンドウ > アセットの書き出し',
        placement: 'MenuBar',
        name: 'アセットの書き出し',
    },
    {
        id: 2164261413,
        label: '効果 > ビデオ > NTSC カラー',
        placement: 'MenuBar',
        name: 'NTSC カラー',
    },
    {
        id: 2164261415,
        label: '効果 > アーティスティック > 水彩画...',
        placement: 'MenuBar',
        name: '水彩画...',
    },
    {
        id: 2164261417,
        label: '効果 > スケッチ > ウォーターペーパー...',
        placement: 'MenuBar',
        name: 'ウォーターペーパー...',
    },
    {
        id: 2164261418,
        label: '効果 > アーティスティック > 粗描き...',
        placement: 'MenuBar',
        name: '粗描き...',
    },
    {
        id: 2164261419,
        label: '効果 > スケッチ > ぎざぎざのエッジ...',
        placement: 'MenuBar',
        name: 'ぎざぎざのエッジ...',
    },
    {
        id: 2164261421,
        label: '効果 > テクスチャ > テクスチャライザー...',
        placement: 'MenuBar',
        name: 'テクスチャライザー...',
    },
    {
        id: 2164261423,
        label: '効果 > ブラシストローク > 墨絵...',
        placement: 'MenuBar',
        name: '墨絵...',
    },
    {
        id: 2164261424,
        label: '効果 > スケッチ > スタンプ...',
        placement: 'MenuBar',
        name: 'スタンプ...',
    },
    {
        id: 2164261425,
        label: '効果 > テクスチャ > ステンドグラス...',
        placement: 'MenuBar',
        name: 'ステンドグラス...',
    },
    {
        id: 2164261426,
        label: '効果 > ブラシストローク > ストローク (スプレー)...',
        placement: 'MenuBar',
        name: 'ストローク (スプレー)...',
    },
    {
        id: 2164261427,
        label: '効果 > アーティスティック > スポンジ...',
        placement: 'MenuBar',
        name: 'スポンジ...',
    },
    {
        id: 2164261428,
        label: '効果 > ブラシストローク > はね...',
        placement: 'MenuBar',
        name: 'はね...',
    },
    {
        id: 2164261429,
        label: '効果 > アーティスティック > こする...',
        placement: 'MenuBar',
        name: 'こする...',
    },
    {
        id: 2164261430,
        label: '効果 > アーティスティック > 粗いパステル画...',
        placement: 'MenuBar',
        name: '粗いパステル画...',
    },
    {
        id: 2164261431,
        label: '効果 > スケッチ > ちりめんじわ...',
        placement: 'MenuBar',
        name: 'ちりめんじわ...',
    },
    {
        id: 2164261432,
        label: '効果 > アーティスティック > エッジのポスタリゼーション...',
        placement: 'MenuBar',
        name: 'エッジのポスタリゼーション...',
    },
    {
        id: 2164261433,
        label: '効果 > アーティスティック > ラップ...',
        placement: 'MenuBar',
        name: 'ラップ...',
    },
    {
        id: 2164261434,
        label: '効果 > スケッチ > プラスター...',
        placement: 'MenuBar',
        name: 'プラスター...',
    },
    {
        id: 2164261435,
        label: '効果 > スケッチ > コピー...',
        placement: 'MenuBar',
        name: 'コピー...',
    },
    {
        id: 2164261436,
        label: '効果 > テクスチャ > パッチワーク...',
        placement: 'MenuBar',
        name: 'パッチワーク...',
    },
    {
        id: 2164261437,
        label: '効果 > アーティスティック > パレットナイフ...',
        placement: 'MenuBar',
        name: 'パレットナイフ...',
    },
    {
        id: 2164261438,
        label: '効果 > アーティスティック > 塗料...',
        placement: 'MenuBar',
        name: '塗料...',
    },
    {
        id: 2164261440,
        label: '効果 > 変形 > 海の波紋...',
        placement: 'MenuBar',
        name: '海の波紋...',
    },
    {
        id: 2164261441,
        label: '効果 > スケッチ > ノート用紙...',
        placement: 'MenuBar',
        name: 'ノート用紙...',
    },
    {
        id: 2164261442,
        label: '効果 > アーティスティック > ネオン光彩...',
        placement: 'MenuBar',
        name: 'ネオン光彩...',
    },
    {
        id: 2164261443,
        label: '効果 > テクスチャ > モザイクタイル...',
        placement: 'MenuBar',
        name: 'モザイクタイル...',
    },
    {
        id: 2164261444,
        label: '効果 > ブラシストローク > インク画 (外形)...',
        placement: 'MenuBar',
        name: 'インク画 (外形)...',
    },
    {
        id: 2164261445,
        label: '効果 > スケッチ > ハーフトーンパターン...',
        placement: 'MenuBar',
        name: 'ハーフトーンパターン...',
    },
    {
        id: 2164261446,
        label: '効果 > スケッチ > グラフィックペン...',
        placement: 'MenuBar',
        name: 'グラフィックペン...',
    },
    {
        id: 2164261447,
        label: '効果 > テクスチャ > 粒状...',
        placement: 'MenuBar',
        name: '粒状...',
    },
    {
        id: 2164261449,
        label: '効果 > 表現手法 > エッジの光彩...',
        placement: 'MenuBar',
        name: 'エッジの光彩...',
    },
    {
        id: 2164261450,
        label: '効果 > 変形 > ガラス...',
        placement: 'MenuBar',
        name: 'ガラス...',
    },
    {
        id: 2164261451,
        label: '効果 > アーティスティック > フレスコ...',
        placement: 'MenuBar',
        name: 'フレスコ...',
    },
    {
        id: 2164261452,
        label: '効果 > アーティスティック > 粒状フィルム...',
        placement: 'MenuBar',
        name: '粒状フィルム...',
    },
    {
        id: 2164261453,
        label: '効果 > アーティスティック > ドライブラシ...',
        placement: 'MenuBar',
        name: 'ドライブラシ...',
    },
    {
        id: 2164261454,
        label: '効果 > 変形 > 光彩拡散...',
        placement: 'MenuBar',
        name: '光彩拡散...',
    },
    {
        id: 2164261455,
        label: '効果 > ブラシストローク > ストローク (暗)...',
        placement: 'MenuBar',
        name: 'ストローク (暗)...',
    },
    {
        id: 2164261456,
        label: '効果 > アーティスティック > カットアウト...',
        placement: 'MenuBar',
        name: 'カットアウト...',
    },
    {
        id: 2164261457,
        label: '効果 > ブラシストローク > 網目...',
        placement: 'MenuBar',
        name: '網目...',
    },
    {
        id: 2164261458,
        label: '効果 > テクスチャ > クラッキング...',
        placement: 'MenuBar',
        name: 'クラッキング...',
    },
    {
        id: 2164261459,
        label: '効果 > スケッチ > クレヨンのコンテ画...',
        placement: 'MenuBar',
        name: 'クレヨンのコンテ画...',
    },
    {
        id: 2164261460,
        label: '効果 > アーティスティック > 色鉛筆...',
        placement: 'MenuBar',
        name: '色鉛筆...',
    },
    {
        id: 2164261461,
        label: '効果 > スケッチ > クロム...',
        placement: 'MenuBar',
        name: 'クロム...',
    },
    {
        id: 2164261462,
        label: '効果 > スケッチ > 木炭画...',
        placement: 'MenuBar',
        name: '木炭画...',
    },
    {
        id: 2164261463,
        label: '効果 > スケッチ > チョーク・木炭画...',
        placement: 'MenuBar',
        name: 'チョーク・木炭画...',
    },
    {
        id: 2164261464,
        label: '効果 > スケッチ > 浅浮彫り...',
        placement: 'MenuBar',
        name: '浅浮彫り...',
    },
    {
        id: 2164261465,
        label: '効果 > ブラシストローク > ストローク (斜め)...',
        placement: 'MenuBar',
        name: 'ストローク (斜め)...',
    },
    {
        id: 2164261466,
        label: '効果 > ブラシストローク > エッジの強調...',
        placement: 'MenuBar',
        name: 'エッジの強調...',
    },
    {
        id: 2164261467,
        label: '効果 > 効果ギャラリー...',
        placement: 'MenuBar',
        name: '効果ギャラリー...',
    },
    {
        id: 2164261469,
        label: '効果 > パスの変形 > 変形...',
        placement: 'MenuBar',
        name: '変形...',
    },
    {
        id: 2164261471,
        label: '効果 > スタイライズ > ドロップシャドウ...',
        placement: 'MenuBar',
        name: 'ドロップシャドウ...',
    },
    {
        id: 2164261472,
        label: '効果 > スタイライズ > 光彩 (外側)...',
        placement: 'MenuBar',
        name: '光彩 (外側)...',
    },
    {
        id: 2164261473,
        label: '効果 > スタイライズ > 光彩 (内側)...',
        placement: 'MenuBar',
        name: '光彩 (内側)...',
    },
    {
        id: 2164261475,
        label: '効果 > 形状に変換 > 長方形...',
        placement: 'MenuBar',
        name: '長方形...',
    },
    {
        id: 2164261476,
        label: '効果 > 形状に変換 > 角丸長方形...',
        placement: 'MenuBar',
        name: '角丸長方形...',
    },
    {
        id: 2164261477,
        label: '効果 > 形状に変換 > 楕円形...',
        placement: 'MenuBar',
        name: '楕円形...',
    },
    {
        id: 2164261478,
        label: '効果 > スタイライズ > 角を丸くする...',
        placement: 'MenuBar',
        name: '角を丸くする...',
    },
    {
        id: 2164261479,
        label: '効果 > パスの変形 > パスの自由変形...',
        placement: 'MenuBar',
        name: 'パスの自由変形...',
    },
    {
        id: 2164261480,
        label: '効果 > パスの変形 > パンク・膨張...',
        placement: 'MenuBar',
        name: 'パンク・膨張...',
    },
    {
        id: 2164261481,
        label: '効果 > パスの変形 > ランダム・ひねり...',
        placement: 'MenuBar',
        name: 'ランダム・ひねり...',
    },
    {
        id: 2164261482,
        label: '効果 > パスの変形 > ラフ...',
        placement: 'MenuBar',
        name: 'ラフ...',
    },
    {
        id: 2164261483,
        label: '効果 > パスの変形 > ジグザグ...',
        placement: 'MenuBar',
        name: 'ジグザグ...',
    },
    {
        id: 2164261484,
        label: '効果 > スタイライズ > 落書き...',
        placement: 'MenuBar',
        name: '落書き...',
    },
    {
        id: 2164261486,
        label: '効果 > ワープ > 円弧...',
        placement: 'MenuBar',
        name: '円弧...',
    },
    {
        id: 2164261487,
        label: '効果 > ワープ > 上弦...',
        placement: 'MenuBar',
        name: '上弦...',
    },
    {
        id: 2164261488,
        label: '効果 > ワープ > 下弦...',
        placement: 'MenuBar',
        name: '下弦...',
    },
    {
        id: 2164261489,
        label: '効果 > ワープ > アーチ...',
        placement: 'MenuBar',
        name: 'アーチ...',
    },
    {
        id: 2164261490,
        label: '効果 > ワープ > でこぼこ...',
        placement: 'MenuBar',
        name: 'でこぼこ...',
    },
    {
        id: 2164261491,
        label: '効果 > ワープ > 貝殻 (下向き)...',
        placement: 'MenuBar',
        name: '貝殻 (下向き)...',
    },
    {
        id: 2164261492,
        label: '効果 > ワープ > 貝殻 (上向き)...',
        placement: 'MenuBar',
        name: '貝殻 (上向き)...',
    },
    {
        id: 2164261493,
        label: '効果 > ワープ > 旗...',
        placement: 'MenuBar',
        name: '旗...',
    },
    {
        id: 2164261494,
        label: '効果 > ワープ > 波形...',
        placement: 'MenuBar',
        name: '波形...',
    },
    {
        id: 2164261495,
        label: '効果 > ワープ > 魚形...',
        placement: 'MenuBar',
        name: '魚形...',
    },
    {
        id: 2164261496,
        label: '効果 > ワープ > 上昇...',
        placement: 'MenuBar',
        name: '上昇...',
    },
    {
        id: 2164261497,
        label: '効果 > ワープ > 魚眼レンズ...',
        placement: 'MenuBar',
        name: '魚眼レンズ...',
    },
    {
        id: 2164261498,
        label: '効果 > ワープ > 膨張...',
        placement: 'MenuBar',
        name: '膨張...',
    },
    {
        id: 2164261499,
        label: '効果 > ワープ > 絞り込み...',
        placement: 'MenuBar',
        name: '絞り込み...',
    },
    {
        id: 2164261500,
        label: '効果 > ワープ > 旋回...',
        placement: 'MenuBar',
        name: '旋回...',
    },
    {
        id: 2164261501,
        label: '効果 > ラスタライズ...',
        placement: 'MenuBar',
        name: 'ラスタライズ...',
    },
    {
        id: 2164261503,
        label: '効果 > SVG フィルター > SVG フィルターを適用...',
        placement: 'MenuBar',
        name: 'SVG フィルターを適用...',
    },
    {
        id: 2164261504,
        label: '効果 > スタイライズ > ぼかし...',
        placement: 'MenuBar',
        name: 'ぼかし...',
    },
    {
        id: 2164261505,
        label: '効果 > パスの変形 > 旋回...',
        placement: 'MenuBar',
        name: '旋回...',
    },
    {
        id: 2164261506,
        label: '効果 > パス > パスのアウトライン',
        placement: 'MenuBar',
        name: 'パスのアウトライン',
    },
    {
        id: 2164261507,
        label: '効果 > パス > パスのオフセット...',
        placement: 'MenuBar',
        name: 'パスのオフセット...',
    },
    {
        id: 2164261508,
        label: '効果 > ぼかし > ぼかし (ガウス)...',
        placement: 'MenuBar',
        name: 'ぼかし (ガウス)...',
    },
    {
        id: 2164261509,
        label: '編集 > カスタム辞書を編集...',
        placement: 'MenuBar',
        name: 'カスタム辞書を編集...',
    },
    {
        id: 2164261512,
        label: 'オブジェクト > パス > グリッドに分割...',
        placement: 'MenuBar',
        name: 'グリッドに分割...',
    },
    {
        id: 2164261514,
        label: '書式 > 大文字と小文字の変更 > すべて大文字',
        placement: 'MenuBar',
        name: 'すべて大文字',
    },
    {
        id: 2164261515,
        label: '書式 > 大文字と小文字の変更 > すべて小文字',
        placement: 'MenuBar',
        name: 'すべて小文字',
    },
    {
        id: 2164261516,
        label: '書式 > 大文字と小文字の変更 > 単語の先頭のみ大文字',
        placement: 'MenuBar',
        name: '単語の先頭のみ大文字',
    },
    {
        id: 2164261517,
        label: '書式 > 大文字と小文字の変更 > 文頭のみ大文字',
        placement: 'MenuBar',
        name: '文頭のみ大文字',
    },
    {
        id: 2164261518,
        label: '書式 > 最適なマージン揃え',
        placement: 'MenuBar',
        name: '最適なマージン揃え',
    },
    {
        id: 2164261519,
        label: '書式 > フォントの検索と置換...',
        placement: 'MenuBar',
        name: 'フォントの検索と置換...',
    },
    {
        id: 2164261520,
        label: '書式 > 欧文用字形の自動置換...',
        placement: 'MenuBar',
        name: '欧文用字形の自動置換...',
    },
    {
        id: 2164261521,
        label: 'オブジェクト > 変形 > 個別に変形...',
        placement: 'MenuBar',
        name: '個別に変形...',
    },
    {
        id: 2164261522,
        label: 'オブジェクト > グラデーションメッシュを作成...',
        placement: 'MenuBar',
        name: 'グラデーションメッシュを作成...',
    },
    {
        id: 2164261523,
        label: '選択 > 選択範囲を反転',
        placement: 'MenuBar',
        name: '選択範囲を反転',
    },
    {
        id: 2164261525,
        label: 'オブジェクト > パス > パスの削除...',
        placement: 'MenuBar',
        name: 'パスの削除...',
    },
    {
        id: 2164261526,
        label: '編集 > カラーを編集 > オーバープリントブラック...',
        placement: 'MenuBar',
        name: 'オーバープリントブラック...',
    },
    {
        id: 2164261528,
        label: 'オブジェクト > テキストの回り込み > 作成',
        placement: 'MenuBar',
        name: '作成',
    },
    {
        id: 2164261529,
        label: 'オブジェクト > テキストの回り込み > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 2164261531,
        label: 'オブジェクト > テキストの回り込み > テキストの回り込みオプション...',
        placement: 'MenuBar',
        name: 'テキストの回り込みオプション...',
    },
    {
        id: 2164261532,
        label: '選択 > オブジェクト > クリッピングマスク',
        placement: 'MenuBar',
        name: 'クリッピングマスク',
    },
    {
        id: 2164261533,
        label: '編集 > カラーを編集 > 彩度調整...',
        placement: 'MenuBar',
        name: '彩度調整...',
    },
    {
        id: 2164261535,
        label: 'オブジェクト > パス > アンカーポイントの追加',
        placement: 'MenuBar',
        name: 'アンカーポイントの追加',
    },
    {
        id: 2164261536,
        label: '編集 > カラーを編集 > カラーバランス調整...',
        placement: 'MenuBar',
        name: 'カラーバランス調整...',
    },
    {
        id: 2164261537,
        label: 'オブジェクト > モザイクオブジェクトを作成...',
        placement: 'MenuBar',
        name: 'モザイクオブジェクトを作成...',
    },
    {
        id: 2164261538,
        label: 'ファイル > パッケージ...',
        placement: 'MenuBar',
        name: 'パッケージ...',
    },
    {
        id: 2164261539,
        label: 'ファイル > Bridge で参照...',
        placement: 'MenuBar',
        name: 'Bridge で参照...',
    },
    {
        id: 2164261540,
        label: 'ファイル > ファイル情報...',
        placement: 'MenuBar',
        name: 'ファイル情報...',
    },
    {
        id: 2164261542,
        label: 'オブジェクト > エンベロープ > ワープで作成...',
        placement: 'MenuBar',
        name: 'ワープで作成...',
    },
    {
        id: 2164261543,
        label: 'オブジェクト > エンベロープ > メッシュで作成...',
        placement: 'MenuBar',
        name: 'メッシュで作成...',
    },
    {
        id: 2164261544,
        label: 'オブジェクト > エンベロープ > 最前面のオブジェクトで作成',
        placement: 'MenuBar',
        name: '最前面のオブジェクトで作成',
    },
    {
        id: 2164261545,
        label: 'オブジェクト > エンベロープ > 解除',
        placement: 'MenuBar',
        name: '解除',
    },
    {
        id: 2164261547,
        label: 'オブジェクト > エンベロープ > エンベロープオプション...',
        placement: 'MenuBar',
        name: 'エンベロープオプション...',
    },
    {
        id: 2164261549,
        label: 'オブジェクト > エンベロープ > 拡張',
        placement: 'MenuBar',
        name: '拡張',
    },
    {
        id: 2164261551,
        label: 'オブジェクト > エンベロープ > オブジェクトを編集',
        placement: 'MenuBar',
        name: 'オブジェクトを編集',
    },
    {
        id: 2164261553,
        label: '編集 > スペルチェック > 自動スペルチェック',
        placement: 'MenuBar',
        name: '自動スペルチェック',
    },
    {
        id: 2164261554,
        label: '編集 > スペルチェック > スペルチェック...',
        placement: 'MenuBar',
        name: 'スペルチェック...',
    },
    {
        id: 2164261555,
        label: '選択 > オブジェクトを一括選択',
        placement: 'MenuBar',
        name: 'オブジェクトを一括選択',
    },
    {
        id: 2164261556,
        label: '編集 > 検索と置換...',
        placement: 'MenuBar',
        name: '検索と置換...',
    },
    {
        id: 2164261557,
        label: '編集 > 次を検索',
        placement: 'MenuBar',
        name: '次を検索',
    },
    {
        id: 2164261559,
        label: '効果 > ドキュメントのラスタライズ効果設定...',
        placement: 'MenuBar',
        name: 'ドキュメントのラスタライズ効果設定...',
    },
    {
        id: 2164261560,
        label: 'オブジェクト > ラスタライズ...',
        placement: 'MenuBar',
        name: 'ラスタライズ...',
    },
    {
        id: 2164261561,
        label: 'ファイル > 選択したスライスを保存...',
        placement: 'MenuBar',
        name: '選択したスライスを保存...',
    },
    {
        id: 2164261562,
        label: '効果 > SVG フィルター > SVG フィルターの読み込み...',
        placement: 'MenuBar',
        name: 'SVG フィルターの読み込み...',
    },
    {
        id: 2164261564,
        label: 'オブジェクト > 画像の切り抜き',
        placement: 'MenuBar',
        name: '画像の切り抜き',
    },
    {
        id: 2164261565,
        label: 'オブジェクト > 重ね順 > 選択しているレイヤーに移動',
        placement: 'MenuBar',
        name: '選択しているレイヤーに移動',
    },
    {
        id: 2164261567,
        label: 'オブジェクト > ロック > 前面のすべてのアートワーク',
        placement: 'MenuBar',
        name: '前面のすべてのアートワーク',
    },
    {
        id: 2164261568,
        label: 'オブジェクト > ロック > その他のレイヤー',
        placement: 'MenuBar',
        name: 'その他のレイヤー',
    },
    {
        id: 2164261569,
        label: 'オブジェクト > 隠す > 前面のすべてのアートワーク',
        placement: 'MenuBar',
        name: '前面のすべてのアートワーク',
    },
    {
        id: 2164261570,
        label: 'オブジェクト > 隠す > その他のレイヤー',
        placement: 'MenuBar',
        name: 'その他のレイヤー',
    },
    {
        id: 2164261571,
        label: '選択 > オブジェクト > 同一レイヤー上のすべて',
        placement: 'MenuBar',
        name: '同一レイヤー上のすべて',
    },
    {
        id: 2164261572,
        label: '選択 > オブジェクト > セグメント',
        placement: 'MenuBar',
        name: 'セグメント',
    },
    {
        id: 2164261575,
        label: '選択 > 前面のオブジェクト',
        placement: 'MenuBar',
        name: '前面のオブジェクト',
    },
    {
        id: 2164261576,
        label: '選択 > 背面のオブジェクト',
        placement: 'MenuBar',
        name: '背面のオブジェクト',
    },
    {
        id: 2164261579,
        label: '選択 > 選択範囲を保存...',
        placement: 'MenuBar',
        name: '選択範囲を保存...',
    },
    {
        id: 2164261580,
        label: '選択 > 選択範囲を編集...',
        placement: 'MenuBar',
        name: '選択範囲を編集...',
    },
    {
        id: 2164261581,
        label: '選択 > 選択範囲を更新',
        placement: 'MenuBar',
        name: '選択範囲を更新',
    },
    {
        id: 2164261585,
        label: 'ファイル > スクリプト > その他のスクリプト...',
        placement: 'MenuBar',
        name: 'その他のスクリプト...',
    },
    {
        id: 2164261586,
        label: '表示 > コーナーウィジェットを隠す',
        placement: 'MenuBar',
        name: 'コーナーウィジェットを隠す',
    },
    {
        id: 2164261587,
        label: 'オブジェクト > パス > パスのアウトライン',
        placement: 'MenuBar',
        name: 'パスのアウトライン',
    },
    {
        id: 2164261588,
        label: 'オブジェクト > パス > パスのオフセット...',
        placement: 'MenuBar',
        name: 'パスのオフセット...',
    },
    {
        id: 2164261589,
        label: '編集 > プリントプリセット...',
        placement: 'MenuBar',
        name: 'プリントプリセット...',
    },
    {
        id: 2164261590,
        label: 'ファイル > プリント...',
        placement: 'MenuBar',
        name: 'プリント...',
    },
    {
        id: 2164261592,
        label: 'オブジェクト > 遠近 > 選択面の図形にする',
        placement: 'MenuBar',
        name: '選択面の図形にする',
    },
    {
        id: 2164261593,
        label: 'オブジェクト > 遠近 > 遠近グリッド上から解除',
        placement: 'MenuBar',
        name: '遠近グリッド上から解除',
    },
    {
        id: 2164261594,
        label: 'オブジェクト > 遠近 > オブジェクトに合わせて面を移動',
        placement: 'MenuBar',
        name: 'オブジェクトに合わせて面を移動',
    },
    {
        id: 2164261595,
        label: 'オブジェクト > 遠近 > テキストを編集',
        placement: 'MenuBar',
        name: 'テキストを編集',
    },
    {
        id: 2164261596,
        label: '編集 > 遠近グリッドプリセット...',
        placement: 'MenuBar',
        name: '遠近グリッドプリセット...',
    },
    {
        id: 2164261599,
        label: '表示 > 遠近グリッド > グリッドを表示',
        placement: 'MenuBar',
        name: 'グリッドを表示',
    },
    {
        id: 2164261600,
        label: '表示 > 遠近グリッド > 定規を表示',
        placement: 'MenuBar',
        name: '定規を表示',
    },
    {
        id: 2164261601,
        label: '表示 > 遠近グリッド > グリッドにスナップ',
        placement: 'MenuBar',
        name: 'グリッドにスナップ',
    },
    {
        id: 2164261602,
        label: '表示 > 遠近グリッド > グリッドをロック',
        placement: 'MenuBar',
        name: 'グリッドをロック',
    },
    {
        id: 2164261603,
        label: '表示 > 遠近グリッド > 測点をロック',
        placement: 'MenuBar',
        name: '測点をロック',
    },
    {
        id: 2164261605,
        label: '表示 > 遠近グリッド > グリッドを定義...',
        placement: 'MenuBar',
        name: 'グリッドを定義...',
    },
    {
        id: 2164261611,
        label: '表示 > 遠近グリッド > グリッドをプリセットとして保存...',
        placement: 'MenuBar',
        name: 'グリッドをプリセットとして保存...',
    },
    {
        id: 2164261612,
        label: 'ファイル > 編集に招待',
        placement: 'MenuBar',
        name: '編集に招待',
    },
    {
        id: 2164261613,
        label: 'ファイル > レビュー用に共有...',
        placement: 'MenuBar',
        name: 'レビュー用に共有...',
    },
    {
        id: 2164261616,
        label: 'ウィンドウ > エクステンション > CC ライブラリ',
        placement: 'MenuBar',
        name: 'CC ライブラリ',
    },
    {
        id: 2164261617,
        label: 'ウィンドウ > バージョン履歴',
        placement: 'MenuBar',
        name: 'バージョン履歴',
    },
    {
        id: 2164261618,
        label: 'ファイル > バージョン履歴',
        placement: 'MenuBar',
        name: 'バージョン履歴',
    },
    {
        id: 2164261619,
        label: 'ウィンドウ > コメント',
        placement: 'MenuBar',
        name: 'コメント',
    },
    {
        id: 2164261620,
        label: '表示 > 遠近グリッド > 一点遠近法 > [1P - 標準ビュー]',
        placement: 'MenuBar',
        name: '[1P - 標準ビュー]',
    },
    {
        id: 2164261621,
        label: '表示 > 遠近グリッド > 二点遠近法 > [2P - 標準ビュー]',
        placement: 'MenuBar',
        name: '[2P - 標準ビュー]',
    },
    {
        id: 2164261622,
        label: '表示 > 遠近グリッド > 三点遠近法 > [3P - 標準ビュー]',
        placement: 'MenuBar',
        name: '[3P - 標準ビュー]',
    },
    {
        id: 'Adobe Scroll Tool',
        label: '手のひらツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pen Tool',
        label: 'ペンツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scale Tool',
        label: '拡大・縮小ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Tool',
        label: '回転ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reflect Tool',
        label: 'リフレクトツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shear Tool',
        label: 'シアーツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scissors Tool',
        label: 'はさみツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Measure Tool',
        label: 'ものさしツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Page Tool',
        label: 'プリント分割ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Object Select Tool',
        label: 'グループ選択ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Select Tool',
        label: 'ダイレクト選択ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Select Tool',
        label: '選択ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Zoom Tool',
        label: 'ズームツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Add Anchor Point Tool',
        label: 'アンカーポイントの追加ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Delete Anchor Point Tool',
        label: 'アンカーポイントの削除ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Anchor Point Tool',
        label: 'アンカーポイントツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Column Graph Tool',
        label: '棒グラフツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Column Graph Tool',
        label: '積み上げ棒グラフツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Graph Tool',
        label: '折れ線グラフツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pie Graph Tool',
        label: '円グラフツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Graph Tool',
        label: '階層グラフツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scatter Graph Tool',
        label: '散布図ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bar Graph Tool',
        label: '横向き棒グラフツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Bar Graph Tool',
        label: '横向き積み上げ棒グラフツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Radar Graph Tool',
        label: 'レーダーチャートツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Type Tool',
        label: '文字ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Type Tool',
        label: 'エリア内文字ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Path Type Tool',
        label: 'パス上文字ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Type Tool',
        label: '文字',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Area Type Tool',
        label: 'エリア内文字',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Path Type Tool',
        label: 'パス上文字',
        placement: 'Tool',
    },
    {
        id: 'Adobe Touch Type Tool',
        label: '文字タッチツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Builder Tool',
        label: 'シェイプ形成ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Paintbucket Tool',
        label: 'ライブペイントツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Face Select Tool',
        label: 'ライブペイント選択ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Dimension Tool',
        label: '寸法ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Gradient Vector Tool',
        label: 'グラデーションツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blend Tool',
        label: 'ブレンドツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Tool',
        label: 'スライスツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Select Tool',
        label: 'スライス選択ツール',
        placement: 'Tool',
    },
    {
        id: 'Perspective Grid Tool',
        label: '遠近グリッドツール',
        placement: 'Tool',
    },
    {
        id: 'Perspective Selection Tool',
        label: '遠近図形選択ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Curvature Tool',
        label: '曲線ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Lasso Tool',
        label: 'なげなわツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Crop Tool',
        label: 'アートボードツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reshape Tool',
        label: 'リシェイプツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Width Tool',
        label: '線幅ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shaper Tool',
        label: 'Shaper ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Puppet Warp Tool',
        label: 'パペットワープツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Magic Wand Tool',
        label: '自動選択ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Knife Tool',
        label: 'ナイフツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Free Transform Tool',
        label: '自由変形ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eraser Tool',
        label: '消しゴムツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Warp Tool',
        label: 'ワープツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe New Twirl Tool',
        label: 'うねりツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pucker Tool',
        label: '収縮ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bloat Tool',
        label: '膨張ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scallop Tool',
        label: 'ひだツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Cyrstallize Tool',
        label: 'クラウンツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Wrinkle Tool',
        label: 'リンクルツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Quick Pen Tool',
        label: 'クイックペンツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Constraints Tool',
        label: 'パス上オブジェクト',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Canvas Tool',
        label: '回転ビューツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Tool',
        label: '鉛筆ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Brush Tool',
        label: 'ブラシツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blob Brush Tool',
        label: '塗りブラシツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Smooth Tool',
        label: 'スムーズツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Erase Tool',
        label: 'パス消しゴムツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Corner Join Tool',
        label: '連結ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eyedropper Tool',
        label: 'スポイトツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Ellipse Shape Tool',
        label: '楕円形ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Regular Polygon Tool',
        label: '多角形ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Star Tool',
        label: 'スターツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangle Shape Tool',
        label: '長方形ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rounded Rectangle Tool',
        label: '角丸長方形ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Spiral Tool',
        label: 'スパイラルツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sprayer Tool',
        label: 'シンボルスプレーツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Shifter Tool',
        label: 'シンボルシフトツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Scruncher Tool',
        label: 'シンボルスクランチツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sizer Tool',
        label: 'シンボルリサイズツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Spinner Tool',
        label: 'シンボルスピンツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Stainer Tool',
        label: 'シンボルステインツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Screener Tool',
        label: 'シンボルスクリーンツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Styler Tool',
        label: 'シンボルスタイルツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Mesh Editing Tool',
        label: 'メッシュツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Flare Tool',
        label: 'フレアツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Tool',
        label: '直線ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Arc Tool',
        label: '円弧ツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangular Grid Tool',
        label: '長方形グリッドツール',
        placement: 'Tool',
    },
    {
        id: 'Adobe Polar Grid Tool',
        label: '同心円グリッドツール',
        placement: 'Tool',
    },
    {
        id: '3D and Materials',
        label: '3D とマテリアル',
        placement: 'Panel',
    },
    {
        id: 'Actions',
        label: 'アクション',
        placement: 'Panel',
    },
    {
        id: 'AdobeAltGlyphsPanel',
        label: '字形',
        placement: 'Panel',
    },
    {
        id: 'AdobeBrush',
        label: 'ブラシ',
        placement: 'Panel',
    },
    {
        id: 'AdobeCharStyles',
        label: '文字スタイル',
        placement: 'Panel',
    },
    {
        id: 'AdobeColorGuidePanel',
        label: 'カラーガイド',
        placement: 'Panel',
    },
    {
        id: 'AdobeFlatteningPreview',
        label: '分割・統合プレビュー',
        placement: 'Panel',
    },
    {
        id: 'AdobeGradientEditor',
        label: 'グラデーション',
        placement: 'Panel',
    },
    {
        id: 'AdobeHorizontalTabPanel',
        label: 'タブ',
        placement: 'Panel',
    },
    {
        id: 'AdobeLayerPalette',
        label: 'レイヤー',
        placement: 'Panel',
    },
    {
        id: 'AdobeObjectAttributes',
        label: '属性',
        placement: 'Panel',
    },
    {
        id: 'AdobeOpenTypeFont',
        label: 'OpenType',
        placement: 'Panel',
    },
    {
        id: 'AdobeParaStyles',
        label: '段落スタイル',
        placement: 'Panel',
    },
    {
        id: 'AdobePropertiesPanel',
        label: 'プロパティ',
        placement: 'Panel',
    },
    {
        id: 'AdobeSeparationPreview',
        label: '分版プレビュー',
        placement: 'Panel',
    },
    {
        id: 'AdobeSwatch_',
        label: 'スウォッチ',
        placement: 'Panel',
    },
    {
        id: 'AdobeVariablesPanel',
        label: '変数',
        placement: 'Panel',
    },
    {
        id: 'AdobeVerticalTabPanel',
        label: 'タブ',
        placement: 'Panel',
    },
    {
        id: 'Align',
        label: '整列',
        placement: 'Panel',
    },
    {
        id: 'Appearance',
        label: 'アピアランス',
        placement: 'Panel',
    },
    {
        id: 'Artboards',
        label: 'アートボード',
        placement: 'Panel',
    },
    {
        id: 'CCX Commenting UXP Webview',
        label: 'コメント',
        placement: 'Panel',
    },
    {
        id: 'CSS',
        label: 'CSS プロパティ (非推奨)',
        placement: 'Panel',
    },
    {
        id: 'CSXSExtension_com.adobe.DesignLibraries.angular_0',
        label: 'CC ライブラリ',
        placement: 'Panel',
    },
    {
        id: 'Character',
        label: '文字',
        placement: 'Panel',
    },
    {
        id: 'Color',
        label: 'カラー',
        placement: 'Panel',
    },
    {
        id: 'Document Info',
        label: 'ドキュメント情報',
        placement: 'Panel',
    },
    {
        id: 'Export',
        label: 'アセットの書き出し',
        placement: 'Panel',
    },
    {
        id: 'GeneratedVariations',
        label: '生成されたバリエーション',
        placement: 'Panel',
    },
    {
        id: 'History',
        label: 'ヒストリー',
        placement: 'Panel',
    },
    {
        id: 'Info',
        label: '情報',
        placement: 'Panel',
    },
    {
        id: 'Links',
        label: 'リンク',
        placement: 'Panel',
    },
    {
        id: 'Magic Wand',
        label: '自動選択',
        placement: 'Panel',
    },
    {
        id: 'Mockup',
        label: 'モックアップ',
        placement: 'Panel',
    },
    {
        id: 'NamedStyle',
        label: 'グラフィックスタイル',
        placement: 'Panel',
    },
    {
        id: 'Navigator',
        label: 'ナビゲーター',
        placement: 'Panel',
    },
    {
        id: 'Paragraph',
        label: '段落',
        placement: 'Panel',
    },
    {
        id: 'Pathfinder',
        label: 'パスファインダー',
        placement: 'Panel',
    },
    {
        id: 'PatternOptionsPanel',
        label: 'パターンオプション',
        placement: 'Panel',
    },
    {
        id: 'Reflow Viewer',
        label: '文字組み更新',
        placement: 'Panel',
    },
    {
        id: 'Retype',
        label: 'Retype',
        placement: 'Panel',
    },
    {
        id: 'SVGInteractivity',
        label: 'SVG インタラクティビティ',
        placement: 'Panel',
    },
    {
        id: 'Stroke',
        label: '線',
        placement: 'Panel',
    },
    {
        id: 'Symbols',
        label: 'シンボル',
        placement: 'Panel',
    },
    {
        id: 'Transform',
        label: '変形',
        placement: 'Panel',
    },
    {
        id: 'Transparency',
        label: '透明',
        placement: 'Panel',
    },
    {
        id: 'Vectorize',
        label: '画像トレース',
        placement: 'Panel',
    },
    {
        id: 'ccx-timeline',
        label: 'バージョン履歴',
        placement: 'Panel',
    },
];
